{
  "account.account": "Профил и сигурност",
  "account.accountDeleted": "Вашият акаунт беше изтрит успешно.",
  "account.accountDescription": "Име, парола, изтриване на акаунта",
  "account.accountSection": "Акаунт",
  "account.changeEmail": "Промяна на имейл",
  "account.changePassword": "Промяна на паролата",
  "account.currentPassword": "Текуща парола",
  "account.dangerZone": "Рискова зона",
  "account.deleteAccount": "Изтриване на вашия акаунт",
  "account.deleteAccountConfirmation": "Сигурни ли сте, че искате да изтриете акаунта си? Това действие е необратимо.",
  "account.deleteAccountDescription": "Това действие изтрива вашия акаунт и цялата ви информация. Няма връщане назад.",
  "account.emailChange": "Промяна на имейл адрес",
  "account.emailChangeConfirmation": "Потвърждение за промяна на имейл",
  "account.emailChangeFailure": "Линкът за промяна на имейл е невалиден или е изтекъл.",
  "account.emailChangeIntro": "Въведете новия си имейл адрес и текущата си парола. Ще изпратим линк на новия адрес: имейлът ви ще бъде променен едва след като го отворите.",
  "account.emailChangeSuccess": "Вашият имейл беше успешно променен на {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Вашият имейл адрес беше успешно променен.",
  "account.emailChangeVerificationSent": "Имейл за потвърждение беше изпратен на новия ви имейл адрес. Моля, проверете входящата си поща и кликнете върху линка, за да потвърдите промяната.",
  "account.manageAccount": "Управление на акаунта",
  "account.newEmailAddress": "Нов имейл адрес",
  "account.newPassword": "Нова парола",
  "account.newPasswordAgain": "Повторете новата парола",
  "account.oldPassword": "Стара парола",
  "account.passwordChange": "Промяна на паролата",
  "account.passwordChangeDescription": "Пазете акаунта си защитен",
  "account.passwordUpdated": "Паролата е актуализирана успешно.",
  "account.profile": "Профил",
  "account.profileUpdated": "Профилът е актуализиран успешно.",
  "account.signedInAs": "Влезли сте като",
  "account.updateYourProfile": "Обновете профила си",
  "account.updateYourProfileDescription": "Име и предпочитания за показване",
  "addons.accountOnHold": "Връзката на вашия акаунт е изтекла. Моля, свържете се отново, за да възобновите актуализациите на данните.",
  "addons.accountOnHoldTitle": "Акаунтът е спрян",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Създайте и извлечете вашия API ключ от тази връзка",
  "addons.ambientWeatherDescription": "Ambient Weather метеостанции (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API ключ",
  "addons.applicationKey": "Ключ за приложение",
  "addons.availableServices": "Налични",
  "addons.cannotDisconnectLastAccount": "Не може да прекъснете единствения си метод за вход. Моля, първо добавете друг метод за вход.",
  "addons.connect": "Свързване",
  "addons.connected": "Свързано",
  "addons.connectedAccounts": "Свързани акаунти",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Свързани",
  "addons.connectedSince": "Свързано от {date}",
  "addons.connectionSection": "Връзка",
  "addons.connectionSuccess": "Профилът {provider} е свързан успешно",
  "addons.davisApiSecret": "Поверителен ключ API",
  "addons.davisApiV2Key": "V2 API ключ",
  "addons.davisDescription": "Метеостанции Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Извлечете вашите V2 API ключове от тази връзка",
  "addons.disconnect": "Прекъсване",
  "addons.disconnectConfirmation": "Сигурни ли сте, че искате да прекъснете профила си {provider}?",
  "addons.disconnectionSuccess": "Профилът {provider} е прекъснат успешно",
  "addons.disconnectProviderDescription": "Спира синхронизирането. Историята ви се запазва.",
  "addons.ecowittCreateAndRetrieveKeys": "Създайте и извлечете едновременно вашия API ключ и ключ за приложението от тази връзка",
  "addons.ecowittDescription": "Ecowitt предлага професионални безжични метеорологични станции, безжични вътрешни външни термометри, монитори за влажност, високо прецизни дъждомери, монитори за качество на въздуха и др.",
  "addons.helpLink": "Как да свържете {provider}",
  "addons.integrationsSection": "Интеграции",
  "addons.myAcuriteAccountOnHold": "Вашият акаунт е задържан. Моля, въведете паролата си, за да свържете отново акаунта си",
  "addons.myAcuriteDescription": "AcuRite е марка метеорологични станции №1 в Северна Америка. Като лидер в технологиите за измерване на времето, температурата и метеорологичните условия, AcuRite ви предоставя подробна информация за вашата вътрешна и външна среда, така че да можете да планирате деня си с увереност.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Използвайте термостата си Netatmo, за да промените температурата в дома си, от леглото си или от другия край на света.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Вашата метеостанция вкъщи",
  "addons.notConnected": "Не е свързано",
  "addons.or": "или",
  "addons.providerAccountDisconnected": "Връзката с вашата метеорологична услуга е изтекла. Моля, свържете се отново, за да възобновите актуализациите на данните.",
  "addons.reconnect": "Повторно свързване",
  "addons.socialConnectionsIntro": "Свържете социалните си профили за бърз вход. Можете да свързвате или прекъсвате профили по всяко време.",
  "addons.weatherflowCreateToken": "Създайте и извлечете своя токен от тази връзка",
  "addons.weatherflowTempestDescription": "Система Tempest Weather с вграден ветромер, дъждомер",
  "addons.weatherServices": "Метеорологични услуги",
  "addons.weatherServicesConnected": "{count, plural, =0 {Няма свързани услуги} one {# свързана услуга} other {# свързани услуги}}",
  "addons.weatherServicesDescription": "Свържете Netatmo, Davis, Weatherflow и други",
  "addons.wundergroundApiKey": "API ключ",
  "addons.wundergroundDescription": "Weather Underground е глобална общност от хора, предоставящи данни от сензори за околната среда като метеорологични станции и монитори за качество на въздуха, за да можем да ви предоставим богатите хиперлокални данни, от които се нуждаете, за да практикувате хобито си",
  "addons.wundergroundRetrieveApiKey": "Извлечете вашия API ключ от тази връзка",
  "addons.wundergroundStationId": "ID на метеостанцията",
  "airQuality.adviceActivityGood": "Идеален ден за активност на открито",
  "airQuality.adviceActivityHazardous": "Избягвайте всякаква физическа активност на открито",
  "airQuality.adviceActivityLabel": "Физическа активност",
  "airQuality.adviceActivityModerate": "Добър ден за активност на открито",
  "airQuality.adviceActivitySensitive": "Обмислете по-кратки и по-малко интензивни занимания на открито",
  "airQuality.adviceActivityUnhealthy": "Ограничете дългите или интензивните занимания и правете повече почивки",
  "airQuality.adviceActivityVeryUnhealthy": "Избягвайте дълги или интензивни занимания; обмислете да ги преместите на закрито",
  "airQuality.adviceGroupsGood": "Не са необходими специални предпазни мерки",
  "airQuality.adviceGroupsHazardous": "Останете на закрито и ограничете активността",
  "airQuality.adviceGroupsLabel": "Чувствителни групи",
  "airQuality.adviceGroupsModerate": "Особено чувствителни хора: по-кратки и по-малко интензивни занимания",
  "airQuality.adviceGroupsSensitive": "По-кратки и по-малко интензивни занимания на открито и повече почивки",
  "airQuality.adviceGroupsUnhealthy": "Избягвайте дълги или интензивни занимания на открито; обмислете да ги преместите на закрито",
  "airQuality.adviceGroupsVeryUnhealthy": "Избягвайте всякаква физическа активност на открито; отложете я или я преместете на закрито",
  "airQuality.adviceTimingLabel": "Кога да излезете",
  "airQuality.adviceTimingMorning": "Най-добре сутрин — тогава озонът е по-нисък",
  "airQuality.airQuality": "Качество на въздуха",
  "airQuality.airQualityIndex": "Индекс за качество на въздуха",
  "airQuality.aqiForecast": "Прогноза за качеството на въздуха",
  "airQuality.co2Fresh": "Свеж",
  "airQuality.co2GettingStale": "Леко застоял",
  "airQuality.co2Stale": "Застоял",
  "airQuality.dailyForecast": "Дневна прогноза",
  "airQuality.dominantPollutant": "Доминиращ замърсител",
  "airQuality.expectedPeak": "Очакван пик",
  "airQuality.good": "Добро",
  "airQuality.goodDescription": "Качеството на въздуха се счита за задоволително и замърсяването на въздуха представлява малък или никакъв риск",
  "airQuality.hazardous": "Опасно",
  "airQuality.hazardousDescription": "Сигнал за здравето: вероятност за сериозни последици за здравето",
  "airQuality.indoorAirQuality": "Качество на въздуха в помещението",
  "airQuality.moderate": "Умерено",
  "airQuality.moderateDescription": "Качеството на въздуха е приемливо; въпреки това има риск за здравето на много малък брой хора, които са необичайно чувствителни към замърсяването на въздуха.",
  "airQuality.noForecastForLocation": "Няма налична прогноза за качеството на въздуха за това място.",
  "airQuality.now": "Сега",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Замърсители",
  "airQuality.recommendations": "Препоръки",
  "airQuality.sensitiveUnhealthy": "Нездравословно за чувствителни групи",
  "airQuality.sensitiveUnhealthyDescription": "Чувствителни хора биха могли да имат последици за здравето. Минимален риск за повечето хора.",
  "airQuality.subIndex": "AQI подиндекс",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Разбиране на индекса",
  "airQuality.unhealthy": "Нездравословно",
  "airQuality.unhealthyDescription": "Вероятни последици за здравето за всички; Чувствителни хора могат да имат по-сериозни последици за здравето",
  "airQuality.veryUnhealthy": "Много нездравословно",
  "airQuality.veryUnhealthyDescription": "Предупреждение за извънредно нездравословно събитие. Вероятност за засягане на цялото население.",
  "alerts.addAlert": "Добавете предупреждение",
  "alerts.addCondition": "Добавете условие",
  "alerts.alertAdded": "Предупреждението е добавено успешно",
  "alerts.alertAuthorizationNotice": "Предупрежденията ще работят само ако разрешите на SmartMixin да показва известия",
  "alerts.alertDeleted": "Предупреждението е изтрито успешно",
  "alerts.alertName": "Име на предупреждението",
  "alerts.alertWhen": "Желая да бъда предупреден, когато:",
  "alerts.aqiGreaterThan": "Индекс на качеството на въздуха, по-голям от",
  "alerts.aqiGreaterThanThreshold": "Индекс на качеството на въздуха по-голям от прага на {value}{unit}",
  "alerts.aqiLessThan": "Индекс на качеството на въздуха, по-малък от",
  "alerts.aqiLessThanThreshold": "Индекс на качеството на въздуха по-малък от прага на {value}{unit}",
  "alerts.atLeastOneCondition": "Трябва да добавите поне едно условие",
  "alerts.co2GreaterThan": "CO2 над",
  "alerts.co2GreaterThanThreshold": "CO2 над праг от {value}{unit}",
  "alerts.co2LessThan": "CO2 под",
  "alerts.co2LessThanThreshold": "CO2 под прага от {value}{unit}",
  "alerts.conditions": "Условия",
  "alerts.conditionsDroppedOnStationChange": "Не се поддържат от тази станция и са премахнати: {conditions}",
  "alerts.createAlert": "Създай предупреждение",
  "alerts.dailyPrecipitationGreaterThan": "Дневни валежи по-големи от",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Дневни валежи над прага от {value}{unit}",
  "alerts.deleteAlert": "Изтрий предупреждение",
  "alerts.editAlert": "Промени предупреждение",
  "alerts.editCondition": "Промени условие",
  "alerts.gustSpeedGreaterThan": "Скорост на порива по-голяма от",
  "alerts.gustSpeedGreaterThanThreshold": "Скорост на порива над праг от {value}{unit}",
  "alerts.gustSpeedLessThan": "Скорост на порива по-малка от",
  "alerts.gustSpeedLessThanThreshold": "Скорост на порива под праг от {value}{unit}",
  "alerts.heatIndexGreaterThan": "Топлинен индекс по-голям от",
  "alerts.heatIndexGreaterThanThreshold": "Топлинен индекс по-голям от прага на {value}{unit}",
  "alerts.heatIndexLessThan": "Топлинен индекс по-малък от",
  "alerts.heatIndexLessThanThreshold": "Топлинен индекс по-малък от прага на {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex по-голям от",
  "alerts.humidexGreaterThanThreshold": "Humidex по-голям от прага на {value}{unit}",
  "alerts.humidexLessThan": "Humidex по-малък от",
  "alerts.humidexLessThanThreshold": "Humidex по-малък от прага на {value}{unit}",
  "alerts.humidityGreaterThan": "Влажност по-голяма от",
  "alerts.humidityGreaterThanThreshold": "Влажност над праг от {value}{unit}",
  "alerts.humidityLessThan": "Влажност по-малка от",
  "alerts.humidityLessThanThreshold": "Влажност под праг от {value}{unit}",
  "alerts.inProgress": "Действащи",
  "alerts.leafWetnessGreaterThan": "Влажност на листата по-голяма от",
  "alerts.leafWetnessGreaterThanThreshold": "Влажност на листата над праг от {value}{unit}",
  "alerts.leafWetnessLessThan": "Влажност на листата по-малка от",
  "alerts.leafWetnessLessThanThreshold": "Влажност на листата под праг от {value}{unit}",
  "alerts.myAlerts": "Мои предупреждения",
  "alerts.noConfiguredAlert": "Все още нямате конфигурирани предупреждения, добавете поне едно",
  "alerts.noiseGreaterThan": "Шум по-голям от",
  "alerts.noiseGreaterThanThreshold": "Шум над праг от {value}{unit}",
  "alerts.noiseLessThan": "Шум по-малък от",
  "alerts.noiseLessThanThreshold": "Шум под праг от {value}{unit}",
  "alerts.noteOnConditions": "Имайте предвид, че предупреждението се задейства, когато всички условия по-долу са потвърдени",
  "alerts.noTriggerHistory": "Това предупреждение все още не е задействано.",
  "alerts.pm10GreaterThan": "Прахови частици 10 над",
  "alerts.pm10GreaterThanThreshold": "Прахови частици 10 над праг от {value}{unit}",
  "alerts.pm10LessThan": "Прахови частици 10 под",
  "alerts.pm10LessThanThreshold": "Прахови частици 10 под праг от {value}{unit}",
  "alerts.pm1GreaterThan": "Прахови частици 1 над",
  "alerts.pm1GreaterThanThreshold": "Прахови частици 1 над праг от {value}{unit}",
  "alerts.pm1LessThan": "Прахови частици 1 под",
  "alerts.pm1LessThanThreshold": "Прахови частици 1 под праг от {value}{unit}",
  "alerts.pm2p5GreaterThan": "Прахови частици 2.5 над",
  "alerts.pm2p5GreaterThanThreshold": "Прахови частици 2.5 над праг от {value}{unit}",
  "alerts.pm2p5LessThan": "Прахови частици 2.5 под",
  "alerts.pm2p5LessThanThreshold": "Прахови частици 2.5 под праг от {value}{unit}",
  "alerts.postStormSummary": "Обобщение след дъжда",
  "alerts.postStormSynopsisHelper": "Ще получите обобщаващо известие след края на всеки дъжд.",
  "alerts.postStormSynopsisSoleCondition": "Обобщението след дъжда не може да се комбинира с други условия.",
  "alerts.precipitationGreaterThan": "Часови валежи по-големи от",
  "alerts.precipitationGreaterThanThreshold": "Часови валежи над прага от {value}{unit}",
  "alerts.pressureGreaterThan": "Налягане по-високо от",
  "alerts.pressureGreaterThanThreshold": "Налягане по-високо от {value}{unit}",
  "alerts.pressureLessThan": "Налягане по-ниско от",
  "alerts.pressureLessThanThreshold": "Налягане по-ниско от {value}{unit}",
  "alerts.rainRateGreaterThan": "Интензивност на дъжда по-голяма от",
  "alerts.rainRateGreaterThanThreshold": "Интензивност на дъжда над прага от {value}{unit}",
  "alerts.sensorNotReporting": "Този сензор в момента не изпраща данни. Предупреждението ще се възобнови, когато сензорът отново започне да изпраща.",
  "alerts.soilMoistureGreaterThan": "Влажност на почвата по-голяма от",
  "alerts.soilMoistureGreaterThanThreshold": "Влажност на почвата над праг от {value}{unit}",
  "alerts.soilMoistureLessThan": "Влажност на почвата по-малка от",
  "alerts.soilMoistureLessThanThreshold": "Влажност на почвата под праг от {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Слънчево излъчване по-високо от",
  "alerts.solarRadiationGreaterThanThreshold": "Слънчево излъчване по-високо от {value}{unit}",
  "alerts.solarRadiationLessThan": "Слънчево излъчване по-ниско от",
  "alerts.solarRadiationLessThanThreshold": "Слънчево излъчване по-ниско от {value}{unit}",
  "alerts.stormChartUnavailable": "Няма налична история на валежите за този дъжд.",
  "alerts.stormDetail": "Обобщение на дъжда",
  "alerts.stormDuration": "Продължителност",
  "alerts.stormEnd": "Край",
  "alerts.stormPeakRate": "Максимална интензивност на дъжда",
  "alerts.stormStart": "Начало",
  "alerts.stormTotal": "Общо валежи",
  "alerts.temperatureGreaterThan": "Температура по-висока от",
  "alerts.temperatureGreaterThanThreshold": "Температура по-висока от {value}{unit}",
  "alerts.temperatureLessThan": "Температура по-ниска от",
  "alerts.temperatureLessThanThreshold": "Температура по-ниска от {value}{unit}",
  "alerts.thresholdOutOfRange": "Трябва да е между {min} и {max}",
  "alerts.thswGreaterThan": "THSW по-голям от",
  "alerts.thswGreaterThanThreshold": "THSW по-голям от прага на {value}{unit}",
  "alerts.thswLessThan": "THSW по-малък от",
  "alerts.thswLessThanThreshold": "THSW по-малък от прага на {value}{unit}",
  "alerts.thwGreaterThan": "THW по-голям от",
  "alerts.thwGreaterThanThreshold": "THW по-голям от прага на {value}{unit}",
  "alerts.thwLessThan": "THW по-малък от",
  "alerts.thwLessThanThreshold": "THW по-малък от прага на {value}{unit}",
  "alerts.triggerHistory": "История на предупреждението",
  "alerts.uvGreaterThan": "UV индекс по-висок от",
  "alerts.uvGreaterThanThreshold": "UV индекс по-висок от {value}{unit}",
  "alerts.uvLessThan": "UV индекс по-нисък от",
  "alerts.uvLessThanThreshold": "UV индекс по-нисък от {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видимост, над праг от {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видимост, под праг от {value}{unit}",
  "alerts.visiblityGreaterThan": "Видимост над",
  "alerts.visiblityLessThan": "Видимост под",
  "alerts.whichMeasure": "За кое измерване искате да бъдете сигнализирани?",
  "alerts.whichModule": "За кой модул бихте искали да бъдете сигнализирани?",
  "alerts.whichSensor": "За кой сензор бихте искали да бъдете сигнализирани?",
  "alerts.windChillGreaterThan": "Wind Chill по-голям от",
  "alerts.windChillGreaterThanThreshold": "Wind Chill по-голям от прага на {value}{unit}",
  "alerts.windChillLessThan": "Wind Chill по-малък от",
  "alerts.windChillLessThanThreshold": "Wind Chill по-малък от прага на {value}{unit}",
  "alerts.windSpeedGreaterThan": "Скорост на вятъра над",
  "alerts.windSpeedGreaterThanThreshold": "Скорост на вятъра над прага на {value}{unit}",
  "alerts.windSpeedLessThan": "Скорост на вятъра под",
  "alerts.windSpeedLessThanThreshold": "Скорост на вятъра под прага на {value}{unit}",
  "appUpdate.updateAvailable": "Налична е актуализация",
  "appUpdate.updateAvailableOpenAppStore": "Докоснете, за да отворите App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Докоснете, за да отворите Google Play",
  "appUpdate.updateAvailableVersion": "Налична е актуализация: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Изисква се нова версия на вашето приложение. Посетете Google Play, за да надстроите.",
  "appUpdate.upgradeRequiredIos": "Изисква се нова версия на вашето приложение. Посетете App Store, за да надстроите.",
  "astral.aboveHorizonAllDay": "Цял ден над хоризонта",
  "astral.aboveTheHorizon": "над хоризонта",
  "astral.apparentSize": "Видим диаметър",
  "astral.apparentSizeAcross": "{size} в диаметър",
  "astral.astronomicalDawn": "Астрономическа зора",
  "astral.astronomicalDusk": "Астрономически здрач",
  "astral.belowHorizonAllDay": "Цял ден под хоризонта",
  "astral.belowHorizonSince": "Под хоризонта от {time}",
  "astral.belowHorizonSinceOn": "Под хоризонта от {day} {time}",
  "astral.brightAllNight": "Светло цяла нощ — никога напълно тъмно",
  "astral.brightestMoment": "Най-светъл момент",
  "astral.civilDawn": "Гражданска зора",
  "astral.civilDusk": "Граждански здрач",
  "astral.darkSkyBetween": "Тъмно небе {from} → {to}",
  "astral.darkSkyWindow": "Тъмно небе {from} → {to} · {duration} без Луната",
  "astral.dayLength": "Продължителност на деня",
  "astral.daylightThroughTheYear": "Продължителност на деня през годината",
  "astral.dayOfCycle": "ден {day} от {total}",
  "astral.doesNotOccurToday": "Днес не се случва",
  "astral.domeHint": "Плъзнете, за да преминете през нощта",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Най-ранен изгрев",
  "astral.earliestSunset": "Най-ранен залез",
  "astral.equinox": "Равноденствие",
  "astral.equinoxIn": "Равноденствие след {days, plural, one {# ден} other {# дни}}",
  "astral.evening": "Вечер",
  "astral.exactPhaseAt": "Точно в {time}",
  "astral.firstQuarter": "Първа четвърт",
  "astral.firstSunriseIn": "Първи изгрев след {days, plural, one {# ден} other {# дни}}",
  "astral.firstSunsetIn": "Първи залез след {days, plural, one {# ден} other {# дни}}",
  "astral.fullMoon": "Пълнолуние",
  "astral.goldenHourBegins": "Начало на златния час",
  "astral.goldenHourEnds": "Край на златния час",
  "astral.highestPoint": "Най-висока точка",
  "astral.inDays": "след {days, plural, one {# ден} other {# дни}}",
  "astral.lastQuarter": "Последна четвърт",
  "astral.latestSunrise": "Най-късен изгрев",
  "astral.latestSunset": "Най-късен залез",
  "astral.litShort": "Осветена",
  "astral.longestDay": "Най-дълъг ден",
  "astral.lowestPoint": "Най-ниска точка",
  "astral.maxAltitudeShort": "Макс.",
  "astral.midday": "Обед",
  "astral.midnightSun": "Среднощно слънце",
  "astral.midnightSunPeriod": "Среднощно слънце",
  "astral.milestoneFootnotePolar": "Тук слънцето нито изгрява, нито залязва в {days, plural, one {# ден} other {# дни}} от годината, затова вместо обичайните крайности на изгрева и залеза списъкът показва кога се случва това.",
  "astral.milestoneFootnoteTemperate": "Най-ранният залез и най-късният изгрев не съвпадат с най-краткия ден — тези две дати се определят от уравнението на времето, а не от слънцестоенето.",
  "astral.moon": "Луна",
  "astral.moonAltitude": "Височина",
  "astral.moonDirection": "Азимут",
  "astral.moonDistance": "Разстояние",
  "astral.moonlessFor": "{duration} без Луната",
  "astral.moonPhases": "Лунни фази",
  "astral.moonrise": "Изгрев на Луната",
  "astral.moonset": "Залез на Луната",
  "astral.moonUpAllNight": "Луната е над хоризонта цяла нощ",
  "astral.moonWashesOutNight": "Луната е над хоризонта от {rise} до {set} и осветява цялата нощ",
  "astral.morning": "Сутрин",
  "astral.nauticalDawn": "Навигационна зора",
  "astral.nauticalDusk": "Навигационен здрач",
  "astral.newMoon": "Новолуние",
  "astral.nextDay": "+1 ден",
  "astral.nextProperlyDarkNight": "Следваща наистина тъмна нощ",
  "astral.nextRise": "следващ изгрев в {time}",
  "astral.nextRiseOn": "следващ изгрев {day} в {time}",
  "astral.nextSevenNights": "Следващите седем нощи",
  "astral.noAstronomicalDarknessTonight": "Тази нощ няма астрономическа тъмнина",
  "astral.noDarkNightAhead": "Няма през следващите две седмици",
  "astral.noSunriseToday": "Днес няма изгрев",
  "astral.nowAtBearing": "сега {altitude} · азимут {direction}",
  "astral.observing": "Наблюдение",
  "astral.ofDaylightLeft": "оставаща светлина",
  "astral.overTheNextThreeWeeks": "през следващите 3 седмици",
  "astral.percentLit": "{percent} осветено",
  "astral.polarNight": "Полярна нощ",
  "astral.polarNightPeriod": "Полярна нощ",
  "astral.rightNow": "В момента",
  "astral.riseShort": "Изгрев",
  "astral.setShort": "Залез",
  "astral.shortestDay": "Най-кратък ден",
  "astral.solarNoon": "Слънчево пладне",
  "astral.solstice": "Слънцестоене",
  "astral.sunBelowHorizon": "Слънцето на {degrees}° под хоризонта",
  "astral.sunEvents": "Слънчеви събития",
  "astral.sunNeverDarkEnough": "Слънцето никога не слиза на 18° под хоризонта",
  "astral.sunNeverSets": "Слънцето не залязва",
  "astral.sunrise": "Изгрев",
  "astral.sunriseAndSunset": "Изгрев и залез",
  "astral.sunriseAt": "Изгрев в {time}",
  "astral.sunset": "Залез",
  "astral.sunsetAt": "Залез в {time}",
  "astral.thisYearAtNorth": "Тази година на {degrees}° с.ш.",
  "astral.thisYearAtSouth": "Тази година на {degrees}° ю.ш.",
  "astral.tonight": "Тази нощ",
  "astral.twilightAllNight": "Здрач цяла нощ — никога напълно тъмно",
  "astral.upFor": "{duration} над хоризонта",
  "astral.usableLight": "Използваема светлина",
  "astral.vsAverage": "{percent} спрямо средното",
  "astral.vsYesterday": "спрямо вчера",
  "astral.waningCrescent": "Намаляващ сърп",
  "astral.waningGibbous": "Намаляваща луна",
  "astral.waxingCrescent": "Нарастващ сърп",
  "astral.waxingGibbous": "Нарастваща луна",
  "astral.whereToLook": "Къде да гледате",
  "astral.withoutTheMoon": "{duration} без Луната",
  "auth.alreadyHaveAccount": "Вече имате акаунт?",
  "auth.authContainerTagline": "Вашето лично табло за времето. Свържете станциите си и получавайте данни в реално време на една ръка разстояние.",
  "auth.backToLogin": "Обратно към входа",
  "auth.checkYourEmail": "Проверете имейла си",
  "auth.continueWithApple": "Продължете с Apple",
  "auth.continueWithFacebook": "Продължете с Facebook",
  "auth.continueWithGoogle": "Продължете с Google",
  "auth.email": "Имейл адрес",
  "auth.emailRequiredLoginFacebook": "Изисква се разрешение за имейл.",
  "auth.emailVerification": "Потвърждение на имейла",
  "auth.emailVerificationFailure": "Възникна проблем с потвърждението на вашия имейл.",
  "auth.emailVerificationSuccess": "Вашият имейл е потвърден успешно.",
  "auth.firstName": "Име",
  "auth.forgotPassword": "Забравена парола?",
  "auth.forgotPasswordSubtitle": "Въведете имейла си и ще ви изпратим връзка за нулиране на паролата.",
  "auth.lastName": "Фамилия",
  "auth.login": "Вход",
  "auth.loginSubtitle": "Добре дошли отново! Моля, въведете вашите данни.",
  "auth.loginToSmartMixinDescription": "Влезте в SmartMixin, за да получите достъп до метеорологичните си станции, да преглеждате анализи и да управлявате личното си табло за времето.",
  "auth.logout": "Изход",
  "auth.logoutConfirmation": "Искате ли да излезете?",
  "auth.noAccountYet": "Все още нямате акаунт?",
  "auth.or": "или",
  "auth.password": "Парола",
  "auth.passwordReset": "Нулиране на парола",
  "auth.passwordResetSuccess": "Вашата парола е актуализирана успешно.",
  "auth.register": "Създайте акаунт",
  "auth.registerDescription": "Създайте безплатен акаунт в SmartMixin, за да свържете метеорологичните си станции, да проследявате метеорологични данни и да получите достъп до мощни аналитични инструменти.",
  "auth.registerSubtitle": "Създайте акаунта си, за да започнете.",
  "auth.restorePassword": "Възстановяване на парола",
  "auth.restorePasswordSuccess": "Изпратихме ви връзка за нулиране на парола на {emailAddress} с допълнителни инструкции.",
  "auth.sendReset": "Изпратете инструкции за нулиране",
  "auth.signInWithApple": "Вход с Apple",
  "auth.socialAccount": "или използвайте акаунта си",
  "auth.staffVerificationCode": "Код за потвърждение",
  "auth.staffVerificationExpiresIn": "Потвърдено. Изтича след {duration}.",
  "auth.staffVerificationInvalidCode": "Грешен код. Опитайте отново.",
  "auth.staffVerificationLoginAsStopped": "Login As беше спрян: въведете код за потвърждение на екрана Debug, за да продължите.",
  "auth.staffVerificationNotEnrolled": "За вашия акаунт не е настроено приложение за удостоверяване. Добавете такова от настройките за сигурност в административния панел.",
  "auth.staffVerificationPrompt": "Въведете 6-цифрения код от приложението за удостоверяване или код за възстановяване, за да използвате Login As и търсенето на потребители.",
  "auth.staffVerificationSetupLink": "Добавяне на приложение за удостоверяване",
  "auth.staffVerificationSubmit": "Потвърди",
  "auth.staffVerificationTitle": "Потвърждение за служители",
  "calendar.afternoon": "Следобед",
  "calendar.april": "Април",
  "calendar.august": "Август",
  "calendar.changePeriod": "Период: {period}. Промяна на периода",
  "calendar.currentDay": "Днес",
  "calendar.dateFormat": "Формат на датата",
  "calendar.day": "Ден",
  "calendar.december": "Декември",
  "calendar.durationHours": "{hours} ч",
  "calendar.durationHoursMinutes": "{hours} ч {minutes} мин",
  "calendar.durationMinutes": "{minutes} мин",
  "calendar.durationMinutesSeconds": "{minutes} мин {seconds} с",
  "calendar.durationSeconds": "{seconds} с",
  "calendar.end": "Край",
  "calendar.endTime": "Край",
  "calendar.evening": "Вечер",
  "calendar.february": "Февруари",
  "calendar.goToNextDay": "Следващ ден",
  "calendar.goToNextMonth": "Следващ месец",
  "calendar.goToNextWeek": "Следваща седмица",
  "calendar.goToNextYear": "Следваща година",
  "calendar.goToPreviousDay": "Предишен ден",
  "calendar.goToPreviousMonth": "Предишен месец",
  "calendar.goToPreviousWeek": "Предишна седмица",
  "calendar.goToPreviousYear": "Предишна година",
  "calendar.hour": "Час",
  "calendar.hoursCount": "{count, plural, one {# час} other {# часа}}",
  "calendar.hoursShort": "ч",
  "calendar.hoursShortCount": "{count, plural, one {# ч} other {# ч}}",
  "calendar.january": "Януари",
  "calendar.july": "Юли",
  "calendar.june": "Юни",
  "calendar.last12Hours": "Последните 12 часа",
  "calendar.last24Hours": "Последните 24 часа",
  "calendar.last30Days": "Последните 30 дни",
  "calendar.last3Hours": "Последните 3 часа",
  "calendar.last6Hours": "Последните 6 часа",
  "calendar.last7Days": "Последните 7 дни",
  "calendar.lastHour": "Последен час",
  "calendar.march": "Март",
  "calendar.max": "Максимално",
  "calendar.may": "Май",
  "calendar.month": "Месец",
  "calendar.monthTotal": "Този месец",
  "calendar.morning": "Сутрин",
  "calendar.nextHours": "Следващите часове",
  "calendar.night": "Нощ",
  "calendar.november": "Ноември",
  "calendar.october": "Октомври",
  "calendar.oneDay": "1 ден",
  "calendar.oneHour": "1 час",
  "calendar.oneMonth": "1 месец",
  "calendar.oneWeek": "1 седмица",
  "calendar.periodRangeSpoken": "от {start} до {end}",
  "calendar.previous24Hours": "Предходните 24 часа",
  "calendar.previous30Days": "Предходните 30 дни",
  "calendar.previous7Days": "Предходните 7 дни",
  "calendar.previousDay": "Предишния ден",
  "calendar.previousHours": "Предишни часове",
  "calendar.previousMonth": "Предишния месец",
  "calendar.previousWeek": "Предишната седмица",
  "calendar.previousYear": "Предишната година",
  "calendar.sameDayLastYear": "На този ден през миналата година",
  "calendar.sameMonthLastYear": "През този месец миналата година",
  "calendar.selectADate": "Изберете дата",
  "calendar.selectAggregation": "Изберете показвана стойност",
  "calendar.selectAMonth": "Изберете месец",
  "calendar.selectAYear": "Изберете година",
  "calendar.selectGranularity": "Изберете детайлност",
  "calendar.selectPeriod": "Изберете период",
  "calendar.september": "Септември",
  "calendar.sixHours": "6 часа",
  "calendar.start": "Начало",
  "calendar.startTime": "Начало",
  "calendar.thirtyMinutes": "30 минути",
  "calendar.threeHours": "3 часа",
  "calendar.timezone": "Часова зона",
  "calendar.today": "Днес",
  "calendar.untilChanged": "До промяна",
  "calendar.untilTime": "До {time}",
  "calendar.untilTodayAt": "До днес в {time}",
  "calendar.untilTomorrowAt": "До утре в {time}",
  "calendar.use24HourFormat": "Използване на 24-часов формат",
  "calendar.week": "Седмица",
  "calendar.year": "Година",
  "calendar.yearToDate": "Тази година",
  "calendar.yesterday": "Вчера",
  "charts.averageOverThePeriod": "Средни стойности за периода",
  "charts.calendarView": "Изглед на календара",
  "charts.charts": "Графики",
  "charts.chartView": "Графичен изглед",
  "charts.comparison": "Сравнение",
  "charts.customizeComparisonMetrics": "Персонализиране на показателите за сравнение",
  "charts.customizeComparisonMetricsDescription": "Плъзнете елементите, за да пренаредите показателите за сравнение. Докоснете иконата с око, за да покажете или скриете показателите.",
  "charts.maxOverThePeriod": "Максимум за периода",
  "charts.measureToDisplay": "Величина за показване",
  "charts.minMaxRange": "Мин. / Макс.",
  "charts.noDataForThisPeriod": "Няма данни за този период",
  "charts.observations": "Наблюдения",
  "charts.observedTemperature": "Измерена температура",
  "charts.showComparison": "Показване на сравнение",
  "charts.stationComparison": "Сравнение на станции",
  "charts.stationComparisonDescription": "Сравнете минали данни за времето с друга станция",
  "charts.sumOverThePeriod": "Натрупано през периода",
  "charts.viewAsList": "Списък",
  "charts.viewAsPeriods": "Периоди",
  "common.add": "Добавете",
  "common.altitude": "Надморска височина",
  "common.analysis": "Анализи",
  "common.average": "Средна стойност",
  "common.back": "Назад",
  "common.backToHome": "Обратно към началото",
  "common.cancel": "Отказ",
  "common.cannotBeEmpty": "Това поле не може да бъде празно.",
  "common.close": "Затвори",
  "common.dailyForecast": "Дневна прогноза",
  "common.default": "По подразбиране",
  "common.delete": "Изтрийте",
  "common.details": "Детайли",
  "common.edit": "Редактирайте",
  "common.exitFullscreen": "Изход от цял екран",
  "common.forecast": "Прогноза",
  "common.frequency": "Честота",
  "common.full": "Пълно",
  "common.fullscreen": "Цял екран",
  "common.help": "Помощ",
  "common.hidden": "Скрити",
  "common.high": "Високо",
  "common.iDontKnowYet": "Не съм решил",
  "common.indoor": "В помещението",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Последна актуализация",
  "common.low": "Ниско",
  "common.maximum": "Максимум",
  "common.medium": "Средно",
  "common.minimum": "Минимум",
  "common.more": "Повече",
  "common.moreInformation": "Повече информация",
  "common.next": "Напред",
  "common.no": "Не",
  "common.noAccountNeeded": "Не е необходим акаунт",
  "common.noItemsAvailable": "Няма налични елементи",
  "common.notNow": "Не сега",
  "common.now": "Сега",
  "common.numberOfActiveWarnings": "{warning_count, plural, one {# активно метеорологично предупреждение} other {# активни метеорологични предупреждения}}",
  "common.openSettings": "Отворете настройките",
  "common.outdoor": "Отвън",
  "common.pageNotFound": "Страницата не е намерена",
  "common.pageNotFoundDescription": "Страницата, която търсите, не съществува или е преместена.",
  "common.rain": "Дъжд",
  "common.share": "Споделете",
  "common.shareImageFailed": "Изображението не можа да бъде споделено",
  "common.shareYourWeather": "Споделете вашите измервания на времето",
  "common.skip": "Пропуснете",
  "common.start": "Започнете",
  "common.unknown": "Неизвестно",
  "common.validate": "Потвърдете",
  "common.validEmail": "Изисква се валиден имейл адрес.",
  "common.very_low": "Много ниско",
  "common.weatherObservations": "Наблюдения за времето",
  "common.welcome": "Добре дошли в SmartMixin!",
  "common.wind": "Вятър",
  "common.yes": "Да",
  "common.zoomImage": "Увеличаване на изображението",
  "compass.E": "И",
  "compass.E_long": "Изток",
  "compass.ENE": "ИСИ",
  "compass.ENE_long": "Изток-Североизток",
  "compass.ESE": "ИЮИ",
  "compass.ESE_long": "Изток-Югоизток",
  "compass.N": "С",
  "compass.N_long": "Север",
  "compass.NE": "СИ",
  "compass.NE_long": "Североизток",
  "compass.NNE": "ССИ",
  "compass.NNE_long": "Север-Североизток",
  "compass.NNW": "ССЗ",
  "compass.NNW_long": "Север-Северозапад",
  "compass.NW": "СЗ",
  "compass.NW_long": "Северозапад",
  "compass.S": "Ю",
  "compass.S_long": "Юг",
  "compass.SE": "ЮИ",
  "compass.SE_long": "Югоизток",
  "compass.SSE": "ЮЮИ",
  "compass.SSE_long": "Юг-Югоизток",
  "compass.SSW": "ЮЮЗ",
  "compass.SSW_long": "Юг-Югозапад",
  "compass.SW": "ЮЗ",
  "compass.SW_long": "Югозапад",
  "compass.W": "З",
  "compass.W_long": "Запад",
  "compass.WNW": "ЗСЗ",
  "compass.WNW_long": "Запад-Северозапад",
  "compass.WSW": "ЗЮЗ",
  "compass.WSW_long": "Запад-Югозапад",
  "dashboard.currentObservations": "Текущи наблюдения",
  "dashboard.currentRainEvent": "Текущо дъждовно събитие",
  "dashboard.currentWeatherConditions": "Текущо време",
  "dashboard.customizeDashboard": "Персонализиране",
  "dashboard.customizeDashboardDescription": "Плъзнете елементите, за да пренаредите таблото. Докоснете иконата с око, за да покажете или скриете секции.",
  "dashboard.dashboard": "Панел",
  "dashboard.dayRangeExpected": "{value} очаквани в {time}",
  "dashboard.dayRangeReached": "{value} в {time}",
  "dashboard.dayRangeSteady": "Постоянно {value} цял ден",
  "dashboard.hiddenSensors": "Скрити сензори",
  "dashboard.lastRainEvent": "Последно дъждовно събитие",
  "dashboard.manageSensors": "Управление на сензори",
  "dashboard.manageSensorsDescription": "Плъзнете елементите, за да пренаредите сензорите. Докоснете иконата с око, за да покажете или скриете сензори. Докоснете името, за да го преименувате.",
  "dashboard.pressureSummary": "Обобщение на налягането",
  "dashboard.rainEvents": "Дъждовни събития",
  "dashboard.rainSummary": "Обобщение на валежите",
  "dashboard.shareOutdoorMeasures": "Споделете вашите външни измервания",
  "dashboard.shareOutdoorMeasuresDescription": "Влезте в общността на SmartMixin, като направите външните си измервания видими за другите. Измерванията ви вкъщи никога няма да бъдат споделяни.",
  "dashboard.temperatureSummary": "Обобщение на температурата",
  "dashboard.windSummary": "Обобщение на вятъра",
  "devices.batteryLevel": "Ниво на батерията",
  "devices.firmwareVersion": "Версия на фърмуера",
  "devices.moduleCount": "{count, plural, one {# модул} other {# модула}}",
  "devices.moduleType": "Тип модул",
  "devices.noNetatmoWeatherStationYet": "Все още нямате метеорологична станция Netatmo.",
  "devices.noOutdoorModule": "Няма функционален външен модул за тази станция.",
  "devices.notReachable": "Няма връзка",
  "devices.serialNumber": "Сериен номер",
  "devices.signalAverage": "Умерен",
  "devices.signalBad": "Слаб",
  "devices.signalGood": "Добър",
  "devices.signalStrength": "Сила на сигнала",
  "devices.signalUnknown": "Неизвестен",
  "devices.visitNetatmoWebsite": "Посетете уебсайта на Netatmo",
  "devices.wifiStrength": "Сила на безжичната връзка",
  "forecastMaps.addColor": "Добавяне на цвят",
  "forecastMaps.addLayer": "Добавяне на слой",
  "forecastMaps.autoPreview": "Авто",
  "forecastMaps.backToMaps": "Назад към картите",
  "forecastMaps.build": "Генериране",
  "forecastMaps.buildCompleted": "Генерирането завърши",
  "forecastMaps.builderMetaDescription": "Съставете собствени прогнозни карти от слоевете на метеорологичните модели.",
  "forecastMaps.builderTitle": "Създател на карти",
  "forecastMaps.buildFailed": "Генерирането се провали. Опитайте отново.",
  "forecastMaps.buildNotPossible": "Тази карта още не може да бъде генерирана — няма налични прогнозни данни.",
  "forecastMaps.buildProgress": "Изчертаване… {completed}/{total} стъпки",
  "forecastMaps.buildStarting": "Стартиране на генерирането…",
  "forecastMaps.byModel": "По модел",
  "forecastMaps.byZone": "По зона",
  "forecastMaps.colormap": "Цветова скала",
  "forecastMaps.colormapCustom": "Персонализирани цветове",
  "forecastMaps.colormapGroupDomain": "Метеорологични шаблони",
  "forecastMaps.colormapGroupMatplotlib": "Научни шаблони",
  "forecastMaps.colorScale": "Цветова скала",
  "forecastMaps.contourLevels": "Нива на изолиниите",
  "forecastMaps.countryCanada": "Канада",
  "forecastMaps.countryFrance": "Франция",
  "forecastMaps.countryGermany": "Германия",
  "forecastMaps.countryItaly": "Италия",
  "forecastMaps.countryScandinavia": "Скандинавия",
  "forecastMaps.countrySpain": "Испания",
  "forecastMaps.countrySwitzerland": "Швейцария",
  "forecastMaps.countryUnitedStates": "Съединени щати",
  "forecastMaps.customColormapMinColors": "Персонализираната цветова скала изисква поне два цвята",
  "forecastMaps.customExtent": "Персонализиран обхват",
  "forecastMaps.displayName": "Показвано име",
  "forecastMaps.downscaling": "Коефициент на разреждане на ветровите флагчета",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Очертаване на област",
  "forecastMaps.east": "Изток",
  "forecastMaps.extentDrawHint": "Плъзнете върху картата, за да очертаете областта",
  "forecastMaps.extentInvalid": "Западът трябва да е по-малък от изтока, а югът — по-малък от севера",
  "forecastMaps.height": "Височина (инчове)",
  "forecastMaps.hourOffset": "+{hour} ч",
  "forecastMaps.invalidHexColor": "Невалиден цвят — използвайте #RRGGBB",
  "forecastMaps.layers": "Слоеве",
  "forecastMaps.layerTypeBarbs": "Ветрови флагчета",
  "forecastMaps.layerTypeContour": "Изолинии",
  "forecastMaps.layerTypeFilledContour": "Запълнени изолинии",
  "forecastMaps.layerTypeMagnitude": "Магнитуд",
  "forecastMaps.layerTypeRaster": "Растер",
  "forecastMaps.layerTypeVectorField": "Векторно поле",
  "forecastMaps.leave": "Изход",
  "forecastMaps.levelsCount": "Брой",
  "forecastMaps.levelsInvalid": "Невалидни нива на изолиниите",
  "forecastMaps.levelsModeArange": "Фиксирана стъпка",
  "forecastMaps.levelsModeExplicit": "Изрични стойности",
  "forecastMaps.levelsModeLinspace": "Равномерно разпределени (брой)",
  "forecastMaps.levelsStep": "Стъпка",
  "forecastMaps.levelsValues": "Стойности",
  "forecastMaps.levelsValuesHint": "Разделени със запетаи, възходящо",
  "forecastMaps.localTimeHint": "Показано в местното ви време",
  "forecastMaps.mapDescription": "Описание",
  "forecastMaps.mapName": "Име на картата",
  "forecastMaps.mapNameRequired": "Въведете име",
  "forecastMaps.mapSettings": "Настройки на картата",
  "forecastMaps.mapView": "Интерактивна карта",
  "forecastMaps.maxLayersReached": "Тази карта достигна максимума от {max} слоя.",
  "forecastMaps.maxValue": "Максимална стойност",
  "forecastMaps.memoryBudgetExceeded": "Резолюцията надвишава бюджета за изчертаване — намалете DPI или височината",
  "forecastMaps.memoryBudgetUsage": "Бюджет за изчертаване: {percent}%",
  "forecastMaps.metaDescription": "Анимирани прогнозни карти, генерирани от изчисленията на метеорологичните модели.",
  "forecastMaps.metric": "Величина",
  "forecastMaps.metricRequired": "Изберете величина",
  "forecastMaps.metricUnavailable": "Не е налично за този модел",
  "forecastMaps.minBelowMax": "Минимумът трябва да е по-малък от максимума",
  "forecastMaps.minMaxRequired": "Минималната и максималната стойност са задължителни за този тип слой",
  "forecastMaps.minValue": "Минимална стойност",
  "forecastMaps.modelNoRun": "Все още няма завършено изчисление",
  "forecastMaps.moveLayerDown": "Преместване надолу",
  "forecastMaps.moveLayerUp": "Преместване нагоре",
  "forecastMaps.myMaps": "Моите карти",
  "forecastMaps.nanClipToMin": "Ограничаване до минимума",
  "forecastMaps.nanMask": "Маскиране",
  "forecastMaps.nanPolicy": "Липсващи данни",
  "forecastMaps.nanSkip": "Пропускане",
  "forecastMaps.noCompletedRun": "Тази карта още не е генерирана. Проверете отново скоро.",
  "forecastMaps.noLayers": "Още няма слоеве. Добавете слой, за да започнете.",
  "forecastMaps.noMapsAvailable": "Все още няма налични прогнозни карти.",
  "forecastMaps.north": "Север",
  "forecastMaps.opacity": "Непрозрачност",
  "forecastMaps.overlayLegend": "Легенда",
  "forecastMaps.pause": "Пауза",
  "forecastMaps.play": "Възпроизвеждане",
  "forecastMaps.pointValueError": "Прогнозата за тази точка не можа да бъде заредена.",
  "forecastMaps.pointValueLoading": "Зареждане на прогнозата…",
  "forecastMaps.pointValueUnavailable": "Няма данни за този час.",
  "forecastMaps.presets": "Шаблони",
  "forecastMaps.preview": "Преглед",
  "forecastMaps.previewEmptyHint": "Настройте поне един валиден слой, за да се изчертае преглед.",
  "forecastMaps.previewFailed": "Прегледът се провали",
  "forecastMaps.previewHour": "Час на прогнозата",
  "forecastMaps.previewRendering": "Изчертаване на прегледа…",
  "forecastMaps.projection": "Проекция",
  "forecastMaps.projectionLambertConformal": "Конформна на Ламберт",
  "forecastMaps.projectionMercator": "Меркаторова",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Стереографска",
  "forecastMaps.regionEurope": "Европа",
  "forecastMaps.regionNorthAmerica": "Северна Америка",
  "forecastMaps.removeColor": "Премахване на цвета",
  "forecastMaps.removeLayer": "Премахване на слоя",
  "forecastMaps.retry": "Опитай отново",
  "forecastMaps.run": "Изчисление: {run}",
  "forecastMaps.save": "Запазване",
  "forecastMaps.selectExtentOnMap": "Избор на област върху картата",
  "forecastMaps.south": "Юг",
  "forecastMaps.title": "Прогнозни карти",
  "forecastMaps.uMetric": "U-компонент",
  "forecastMaps.unitConversion": "Преобразуване на единици",
  "forecastMaps.unitNone": "Без",
  "forecastMaps.unsavedChangesBody": "Имате незапазени промени. Изход и отхвърляне?",
  "forecastMaps.unsavedChangesTitle": "Незапазени промени",
  "forecastMaps.useCurrentView": "Използване на текущия изглед",
  "forecastMaps.useModelDomain": "Изкл.: използва се цялата област на модела",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Величините U и V трябва да са различни",
  "forecastMaps.valueBetween": "Трябва да е между {min} и {max}",
  "forecastMaps.variable": "Променлива",
  "forecastMaps.viewMap": "Преглед на картата",
  "forecastMaps.vMetric": "V-компонент",
  "forecastMaps.west": "Запад",
  "forecastMaps.windAnimation": "Анимация на вятъра",
  "forecastModels.addForecastModel": "Добавяне на модел",
  "forecastModels.atYourStations": "Налични на вашите станции",
  "forecastModels.coverageLoading": "Изчисляваме кои от вашите станции покрива всеки модел…",
  "forecastModels.description_AROME": "Високорезолюционният модел на Météo France, позволяващ разрешаване на конвекция, над Западна Европа с резолюция 1,3 км. Най-добрият в класа си за краткосрочни прогнози във Франция; обновява се на всеки три часа.",
  "forecastModels.description_ARPEGE_EU": "Европейската вложена област на модела ARPEGE на Météo France с резолюция 10 км. Средносрочни прогнози над Европа, обновявани четири пъти дневно.",
  "forecastModels.description_ARPEGE_GLOBAL": "Глобалният числен модел за прогноза на времето на Météo France с резолюция 25 км, до около 4 дни. Обновява се четири пъти дневно.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI на DMI: модел, позволяващ разрешаване на конвекция, над северозападна Европа — Дания, Бенелюкс, Ирландия, Обединеното кралство и Скандинавия — с резолюция 2 км до 60 часа, обновяван осем пъти дневно. Съдържа модифицирани отворени данни на DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (глобална детерминистична прогнозна система) на Environment Canada: световен средносрочен модел с резолюция 15 км до 10 дни, обновяван два пъти дневно.",
  "forecastModels.description_EC_HRDPS": "High Resolution Deterministic Prediction System (високоразделителна детерминистична прогнозна система) на Environment Canada: модел, позволяващ разрешаване на конвекция, над Канада и северната част на САЩ с резолюция 2,5 км до 48 часа, обновяван четири пъти дневно.",
  "forecastModels.description_EC_RDPS": "Regional Deterministic Prediction System (регионална детерминистична прогнозна система) на Environment Canada: средносрочен модел над Северна Америка с резолюция 10 км, обновяван четири пъти дневно.",
  "forecastModels.description_ECMWF_HRES": "Флагманският модел с висока разделителна способност (IFS) на Европейския център за средносрочни прогнози на времето, широко смятан за водещата глобална прогнозна система в света. Покрива цялата планета с разделителна способност 25 км до 15 дни, обновяван четири пъти дневно. Съдържа модифицирани отворени данни на ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Водещият глобален модел със среден обхват на NOAA. Покрива цялата планета с резолюция 25 км до 16 дни, обновява се четири пъти дневно.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh на NOAA: модел, позволяващ разрешаване на конвекция, над континентална САЩ с резолюция 3 км, обновяван всеки час. Най-подходящ за много краткосрочни прогнози на гръмотевични бури и тежки атмосферни условия.",
  "forecastModels.description_ICON": "Глобалният модел ICON на DWD с разделителна способност 13 km, покриващ цялата планета до 7,5 дни, обновяван четири пъти дневно. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I на ItaliaMeteo, разработван съвместно с ARPAE: модел, позволяващ разрешаване на конвекция, над Италия с резолюция 2,2 км до 72 часа, обновяван два пъти дневно. Съдържа отворени данни на ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Контролният цикъл на ICON-CH1-EPS на MeteoSwiss: модел, позволяващ разрешаване на конвекция, над Алпите с резолюция 1 км до 33 часа, обновяван на всеки три часа.",
  "forecastModels.description_ICON_CH2": "Контролният цикъл на ICON-CH2-EPS на MeteoSwiss: модел, позволяващ разрешаване на конвекция, над Алпите — Швейцария и околния алпийски регион — с резолюция 2,1 км до 120 часа, обновяван четири пъти дневно.",
  "forecastModels.description_ICON_DE": "Високорезолюционният модел на DWD, позволяващ разрешаване на конвекция, над Германия и съседните страни с резолюция 2,2 км. Краткосрочни прогнози, обновявани два пъти дневно. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Европейската вложена област на модела ICON на DWD с резолюция 7 км, покриваща Европа и Северния Атлантик. Средносрочни прогнози, обновявани четири пъти дневно. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Откритата услуга за прогноза на времето на Норвежкия метеорологичен институт, която съчетава скандинавски модели с висока резолюция с данни от ECMWF за предоставяне на глобални прогнози до 10 дни напред.",
  "forecastModels.description_MF_AROME_ANTILLES": "Вложена област на AROME над френските Антили (Гваделупа, Мартиника) с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "forecastModels.description_MF_AROME_GUYANE": "Вложена област на AROME над френска Гвиана с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Вложена област на AROME над Нова Каледония с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Вложена област на AROME над френска Полинезия с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Вложена област на AROME над Реюнион и Майот с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "forecastModels.description_RRFS_CONUS": "Системата Rapid Refresh Forecast на NOAA над континенталните САЩ с резолюция 3 km. Часови прогнози, обновявани осем пъти дневно, до 84 часа при четирите основни цикъла и 18 часа при останалите.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Системата Rapid Refresh Forecast на NOAA, обхващаща цяла Северна Америка с резолюция 13 km. Часови прогнози до 84 часа, обновявани четири пъти дневно.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Водещата прогноза на SmartMixin. За всеки час на вашето местоположение избираме най-добрия наличен модел — обикновено високорезолюционен регионален модел, където такъв съществува (AROME във Франция, ICON-D2 в Германия, HRRR в САЩ, ARPEGE Europe в континента…) и преминаваме към глобален модел другаде — след което попълваме всички пропуски от съседни източници. Резултатът е една безпроблемна прогноза, покриваща навсякъде по света до 14 дни, автоматично обновявана всеки път, когато някой от базовите модели се актуализира.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Собствената глобална прогноза на Weatherflow, която смесва множество числени модели за времето с наблюдения от своята мрежа от метеорологични станции Tempest. 10-дневен световен хоризонт.",
  "forecastModels.everywhereElse": "Навсякъде другаде",
  "forecastModels.everywhereElseFoot": "Използва се на всяка станция, до която предпочитаните ви модели не достигат.",
  "forecastModels.everywhereElsePick": "Изберете един",
  "forecastModels.fallbackBlend": "Смес SmartMixin",
  "forecastModels.fallbackBlendSub": "Комбинира няколко модела, всеки там, където е най-силен.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES навсякъде, докъдето достига.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Глобалният модел на NOAA. Това, което всеки акаунт използва днес.",
  "forecastModels.fallbackResolution": "Най-висока разделителна способност",
  "forecastModels.fallbackResolutionSub": "Най-фината мрежа, налична на всяка станция.",
  "forecastModels.forecastChipLabelWithRun": "{model}, изчисление {run}",
  "forecastModels.forecastChipRunHint": "Натиснете продължително, за да покажете или скриете последното изчисление",
  "forecastModels.forecastComparisonDescription": "Сравнете детайлите от моделите на прогнозата от няколко източника",
  "forecastModels.forecastFollowingPreferences": "Според вашите предпочитания",
  "forecastModels.forecastModel": "Прогнозен модел",
  "forecastModels.forecastModelComparison": "Сравнение на прогнозните модели",
  "forecastModels.forecastModelCoverage": "Покритие",
  "forecastModels.forecastModelDescription": "Описание",
  "forecastModels.forecastModels": "Прогностични модели",
  "forecastModels.forecastModelScopeGlobal": "Глобален",
  "forecastModels.forecastModelScopeGlobalDescription": "Този модел обхваща цялата планета.",
  "forecastModels.forecastModelScopeRegional": "Регионален",
  "forecastModels.forecastModelScopeRegionalDescription": "Този модел обхваща само определен регион.",
  "forecastModels.forecastModelSpecifications": "Спецификации",
  "forecastModels.forecastNoPinLocation": "Нито един предпочитан модел не достига това местоположение — решава „навсякъде другаде“.",
  "forecastModels.forecastNoPinStation": "Нито един предпочитан модел не достига тази станция — решава „навсякъде другаде“.",
  "forecastModels.forecastNoPreferredModels": "Все още няма зададени предпочитани модели.",
  "forecastModels.forecastOverrideElsewhere": "Вашите предпочитания важат навсякъде другаде.",
  "forecastModels.forecastPickForLocation": "Или изберете един за това местоположение",
  "forecastModels.forecastPickForStation": "Или изберете един за тази станция",
  "forecastModels.forecastPinWinsLocation": "{model} — първият ви предпочитан модел, който достига това местоположение.",
  "forecastModels.forecastPinWinsStation": "{model} — първият ви предпочитан модел, който достига тази станция.",
  "forecastModels.forecastServedNowHere": "В момента тук това е {model}",
  "forecastModels.forecastSetForLocation": "Зададено за това местоположение",
  "forecastModels.forecastSetForStation": "Зададено за тази станция",
  "forecastModels.forecastSettingsRowSub": "Предпочитани модели и какво важи навсякъде другаде",
  "forecastModels.forecastStopUsingHere": "Спри използването тук",
  "forecastModels.forecastUseForLocation": "Използвай {model} за това местоположение",
  "forecastModels.forecastUseForStation": "Използвай {model} за тази станция",
  "forecastModels.forecastUsePreferred": "Използвай предпочитаните ми модели",
  "forecastModels.frequencyHourly": "На всеки час",
  "forecastModels.horizon": "Хоризонт",
  "forecastModels.horizonValue": "до {value} часа",
  "forecastModels.meshSize": "Размер на мрежата",
  "forecastModels.pickerShowAll": "Показване на целия каталог",
  "forecastModels.pickerUnreachable": "{count, plural, one {Още # модел не достига} other {Още # модела не достигат}} до нито една от вашите станции",
  "forecastModels.pinInUse": "В употреба",
  "forecastModels.pinShadowed": "Никога не се използва — модел по-горе покрива всички ваши станции",
  "forecastModels.pinSlots": "{used} от {max} · изберете модел",
  "forecastModels.pinSlotsFull": "{max, plural, one {Единственото място е заето. Премахнете модела му, за да добавите друг.} other {Всички # места са заети. Премахнете едно, за да добавите друго.}}",
  "forecastModels.pinsUncoveredCount": "{used} от вашите {count, plural, one {# станция} other {# станции}}: нито един предпочитан модел не достига до {used, plural, =1 {нея} other {тях}} — решава „навсякъде другаде“.",
  "forecastModels.pinsUncoveredNamed": "{stations}: нито един предпочитан модел не достига до {count, plural, one {нея} other {тях}} — решава „навсякъде другаде“.",
  "forecastModels.pinUnreachable": "Никога не се използва — не достига до нито една ваша станция",
  "forecastModels.pinUsedAt": "Използва се на {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Използва се на вашата станция} other {Използва се на всички # станции}}",
  "forecastModels.pinUsedAtSome": "Използва се на {used} от {count, plural, one {# станция} other {# станции}}",
  "forecastModels.preferredModels": "Предпочитани модели",
  "forecastModels.preferredModelsAll": "Един списък, всички станции",
  "forecastModels.preferredModelsOne": "Един списък, важи навсякъде",
  "forecastModels.publisher": "Разработчик",
  "forecastModels.removePreferredModel": "Премахване на {model} от предпочитаните модели",
  "forecastModels.resetForecastPreference": "Възстановяване на стойностите по подразбиране",
  "forecastModels.resetForecastPreferenceHint": "Изчиства предпочитаните модели и връща настройката по подразбиране на SmartMixin.",
  "forecastModels.servedNowMany": "В момента: GFS {count, plural, one {на вашата станция} other {на всички # станции}}.",
  "forecastModels.servedNowNone": "В момента: GFS навсякъде.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin мултимодел",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Прогноза Weatherflow",
  "forecastModels.weatherForecastModels": "Модели за прогноза на времето",
  "helpCenter.articleCount": "{count, plural, one {# статия} other {# статии}}",
  "helpCenter.articleNotFound": "Статията не е намерена",
  "helpCenter.articleNotFoundDescription": "Статията, която търсите, не съществува.",
  "helpCenter.backToHelpCenter": "Обратно към помощния център",
  "helpCenter.browseByCategory": "Преглед по категория",
  "helpCenter.categoryNotFound": "Категорията не е намерена",
  "helpCenter.categoryNotFoundDescription": "Тази категория не съществува или няма статии.",
  "helpCenter.contactSupport": "Свържете се с поддръжката",
  "helpCenter.feedbackHelpsImprove": "Вашето мнение ни помага да подобрим помощните статии.",
  "helpCenter.feedbackReasonNotAnswer": "Не отговаря на въпроса ми",
  "helpCenter.feedbackReasonOutdated": "Информацията е остаряла",
  "helpCenter.feedbackReasonUnclear": "Инструкциите са неясни",
  "helpCenter.feedbackWhatWentWrong": "Какъв беше проблемът?",
  "helpCenter.helpCategoryAccount": "Акаунт",
  "helpCenter.helpCategoryBilling": "Фактуриране",
  "helpCenter.helpCategoryForecast": "Прогнози",
  "helpCenter.helpCategoryGettingStarted": "Първи стъпки",
  "helpCenter.helpCategoryProviders": "Доставчици",
  "helpCenter.helpCategoryStations": "Станции",
  "helpCenter.helpCategoryTroubleshooting": "Отстраняване на проблеми",
  "helpCenter.helpCenter": "Помощен център",
  "helpCenter.landingDescription": "Намерете отговори на често задавани въпроси и научете как да извлечете максимума от SmartMixin.",
  "helpCenter.linkToSection": "Връзка към този раздел",
  "helpCenter.menuItemDescription": "Често задавани въпроси и ръководства",
  "helpCenter.minRead": "{minutes} мин четене",
  "helpCenter.onThisPage": "На тази страница",
  "helpCenter.platformMobileApp": "Мобилно приложение",
  "helpCenter.platformMobileOnly": "Само в мобилното приложение",
  "helpCenter.platformWebApp": "Уеб приложение",
  "helpCenter.platformWebOnly": "Само в уеб приложението",
  "helpCenter.popularArticles": "Популярни статии",
  "helpCenter.relatedArticles": "Свързани статии",
  "helpCenter.searchArticles": "Търсене на статии...",
  "helpCenter.stillNeedHelp": "Все още се нуждаете от помощ?",
  "helpCenter.stillNeedHelpDescription": "Ако тази статия не отговори на въпроса ви, с удоволствие ще ви помогна лично.",
  "helpCenter.supportEmailSubject": "Помощ за SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Помощ за SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Благодарим ви за обратната връзка!",
  "helpCenter.wasArticleHelpful": "Полезна ли беше тази статия?",
  "intro.locationDescription": "Активирайте достъп до местоположението, за да получите точни прогнози, съобразени с вашата точна област — без универсални прогнози.",
  "intro.locationTitle": "Прогнози, направени за вас",
  "intro.notificationDescription": "Включете известия, за да получавате навременни предупреждения за промени във времето, които са важни за вас — дъжд, сняг или тежки условия, точно когато трябва да знаете.",
  "intro.notificationsTitle": "Никога не пропускайте промяна във времето",
  "intro.readyDescription": "Насладете се на точни прогнози, реално време метеорологична информация и данни от станции по целия свят — всичко в едно мощно приложение.",
  "intro.readyTitle": "Всичко е готово!",
  "intro.welcomeDescription": "Вземете хиперлокални прогнози от водещи метеорологични агенции — плюс достъп до над 40 000 метеорологични станции по целия свят, за да видите реалните условия, минали и настоящи.",
  "intro.welcomeTitle": "Вашето време, преосмислено",
  "landing.alsoAvailableOn": "Налично също в:",
  "landing.featureAlertsDescription": "Задайте персонализирани прагове за всеки показател. Получавайте известие, когато температурата спадне, започне да вали или вятърът се усили.",
  "landing.featureAlertsTitle": "Интелигентни известия",
  "landing.featureAnalyticsDescription": "Интерактивни графики, анализ на тенденции и подробна статистика. Задълбочете се в данните за температура, влажност, налягане, дъжд и вятър.",
  "landing.featureAnalyticsTitle": "Разширена аналитика",
  "landing.featureExportDescription": "Получете всичките си метеорологични данни по имейл като таблица на Excel, готова за по-нататъшен анализ в Excel, Google Sheets или любимите ви инструменти.",
  "landing.featureExportTitle": "Експортирайте данните си",
  "landing.featureForecastDescription": "Достъп до {count, plural, one {#+ професионален прогностичен модел} other {#+ професионални прогностични модела}}, включително ECMWF, GFS и регионални модели. Сравнете ги един до друг, за да направите свои собствени прогнози.",
  "landing.featureForecastTitle": "Сравнете прогнозните модели",
  "landing.featureHistoryDescription": "Достъп до исторически данни с почасова, дневна и месечна скала. Експортирайте ги в Excel за изследвания или лични архиви.",
  "landing.featureHistoryTitle": "Богата история",
  "landing.featureMultiBrandDescription": "Свържете Netatmo, Davis, Tempest, Ecowitt, Ambient Weather и други. Без повече превключване между приложения.",
  "landing.featureMultiBrandTitle": "Всички марки, едно приложение",
  "landing.featuresSubtitle": "SmartMixin ви дава инструментите да анализирате, сравнявате и разбирате метеорологичните си данни като професионалист.",
  "landing.featuresTitle": "Създадено за любителите на данни",
  "landing.finalCtaButton": "Създайте безплатен акаунт",
  "landing.finalCtaSubtitle": "Присъединете се към хиляди ентусиасти на времето, които се доверяват на SmartMixin.",
  "landing.finalCtaTitle": "Готови ли сте да се задълбочите в метеорологичните си данни?",
  "landing.heroCta": "Започнете безплатно",
  "landing.heroDescription": "Задълбочена аналитика, красиви графики и професионални прогнози — всички ваши метеорологични станции, обединени в едно мощно приложение.",
  "landing.heroSecondaryCta": "Разгледайте картата",
  "landing.heroTagline": "За ентусиасти на времето",
  "landing.heroTitle": "Вижте времето както никога досега",
  "landing.pricingFeatureAdvancedMetrics": "Разширени метрики",
  "landing.pricingFeatureAlerts": "Персонализирани известия",
  "landing.pricingFeatureExport": "Експорт на данни (Excel)",
  "landing.pricingFeatureForecastComparison": "Сравнение на прогнози",
  "landing.pricingFeatureForecasts": "Прогностични модели",
  "landing.pricingFeatureForecastsFreeTier": "1 модел",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ модел} other {#+ модела}}",
  "landing.pricingFeatureReports": "Анализи и справки",
  "landing.pricingFeatureStationComparison": "Сравнение на станции",
  "landing.pricingFeatureWidgets": "Уиджети на началния екран",
  "landing.pricingFeatureYearOverYear": "Анализ година по година",
  "landing.pricingFreeCta": "Започнете",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Най-популярно",
  "landing.pricingPremiumCta": "Започнете",
  "landing.pricingPremiumDescription": "От 1,99 €/месец — абонирайте се в уеб, App Store или Google Play",
  "landing.pricingSubtitle": "Започнете безплатно, надградете когато имате нужда от повече.",
  "landing.pricingTitle": "Прости, прозрачни цени",
  "landing.statBrands": "Поддържани марки",
  "landing.statForecasts": "Прогностични модела",
  "landing.statStations": "Метеорологични станции",
  "landing.supportedDevicesNote": "Плюс над {count, number} обществени станции от мрежата на Световната метеорологична организация",
  "landing.supportedDevicesSubtitle": "Свържете съществуващата си метеорологична станция за минути. Поддържаме {count, plural, one {# водеща марка} other {# водещи марки}} и броят им расте.",
  "landing.supportedDevicesTitle": "Работи с вашата станция",
  "metrics.absolutePressure": "Абсолютно налягане",
  "metrics.airDensity": "Плътност на въздуха",
  "metrics.airGap": "Въздушна междина",
  "metrics.apparentTemperature": "Привидна температура",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Средно",
  "metrics.avg_wind": "Средна скорост на вятъра",
  "metrics.beaufort": "Бофорт",
  "metrics.blackGlobeTemperature": "Темп. черна сфера",
  "metrics.boilerOn": "Нагревател ВКЛ",
  "metrics.boilerOnInHours": "Нагревател ВКЛ (часове)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Проводимост",
  "metrics.dailyPrecipitation": "Дневни валежи",
  "metrics.dailyRain": "Дневен дъжд",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Дълбочина",
  "metrics.depthSensors": "Сензори за дълбочина",
  "metrics.dewPoint": "Точка на оросяване",
  "metrics.distance": "Разстояние",
  "metrics.downTrend": "Надолу",
  "metrics.ET": "Евапотранспирация",
  "metrics.etToday": "Евапотранспирация днес",
  "metrics.feelsLike": "Усеща се като",
  "metrics.feelsLikeWithFormula": "Усеща се като ({formula})",
  "metrics.frostPoint": "Точка на скреж",
  "metrics.gust": "Порив",
  "metrics.hail": "Градушка",
  "metrics.heatIndex": "Топлинен индекс",
  "metrics.heatingDegreeDays": "Отоплителни градусодни",
  "metrics.heatingPower": "Отоплителна мощност",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Влажност",
  "metrics.lastLightningImpact": "Последен удар",
  "metrics.lastMeasure": "Последно измерване",
  "metrics.leafSensors": "Сензори за листа",
  "metrics.leafWetness": "Влажност на листата",
  "metrics.lightningDistance": "Разстояние",
  "metrics.lightningStrikeCount": "Брой мълнии",
  "metrics.lightningStrikeDistance": "Разстояние от мълния",
  "metrics.max": "Макс.",
  "metrics.max_gust": "Макс. порив",
  "metrics.maxToday": "Макс. днес",
  "metrics.min": "Мин.",
  "metrics.noise": "Шум",
  "metrics.normalizedHeatingCoefficient": "Нормализиран коефициент на нагряване",
  "metrics.outdoorTemperature": "Външна температура",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Валеж",
  "metrics.pressure": "Налягане",
  "metrics.rain": "Дъжд",
  "metrics.rainDurationValue": "Продължителност на дъжда: {duration}",
  "metrics.rainfallMeasurement": "Измерване на количество валежи",
  "metrics.rainRate": "Интензивност на дъжда",
  "metrics.relativePressure": "Относително налягане",
  "metrics.setPoint": "Зададена точка",
  "metrics.snow": "Сняг",
  "metrics.snowfall": "Снеговалеж",
  "metrics.soilMoisture": "Влага",
  "metrics.soilSensors": "Почвени сензори",
  "metrics.soilWaterTension": "Водно напрежение на почвата",
  "metrics.solarEnergy": "Слънчева енергия",
  "metrics.solarRadiation": "Слънчево излъчване",
  "metrics.speed": "Скорост",
  "metrics.stableTrend": "Стабилен",
  "metrics.sum": "Сума",
  "metrics.temperature": "Температура",
  "metrics.temperatureSensors": "Сензори за температура и влажност",
  "metrics.temperatureShort": "Темп.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "нагоре",
  "metrics.uv": "UV",
  "metrics.visibility": "Видимост",
  "metrics.weatherCondition": "Метеорологични условия",
  "metrics.wetBulbGlobeTemperature": "Темп. мокра сфера",
  "metrics.wetBulbTemperature": "Темп. на мокър термометър",
  "metrics.wind": "Вятър",
  "metrics.windChill": "Wind Chill",
  "metrics.windDirection": "Посока на вятъра",
  "metrics.windMeasurement": "Измерване на вятъра",
  "metrics.windRun": "Път на вятъра",
  "metrics.windRunDescription": "Пътят на вятъра е общото разстояние, изминато от вятъра за определен период от време",
  "metrics.windSpeed": "Скорост на вятъра",
  "network.cancelError": "Заявката е отменена",
  "network.connectionError": "Сървърът не е достъпен",
  "network.networkError": "Няма налична мрежа",
  "network.serverError": "Нещо се обърка...",
  "network.timeoutError": "Времето за изчакване на връзката изтече",
  "network.unknownError": "Неизвестна грешка",
  "premium.alreadyPremium": "Вече имате премиум акаунт!",
  "premium.bestValue": "Най-изгодно",
  "premium.billingDetailsAndroid": "Безплатен пробен период: няма да бъдете таксувани, ако анулирате поне 24 часа преди края на пробния период. След това абонаментът ви за SmartMixin се подновява автоматично, освен ако не го анулирате поне 24 часа преди края на текущия период; можете да анулирате по всяко време от настройките на акаунта си в Google Play. Всяко подновяване се таксува по цената, показана на бутона по-горе. Плащането се таксува от акаунта ви в Google Play при потвърждаване на покупката и в началото на всеки период на подновяване.",
  "premium.billingDetailsIos": "Безплатен пробен период: няма да бъдете таксувани, ако анулирате поне 24 часа преди края на пробния период. След това абонаментът ви за SmartMixin се подновява автоматично, освен ако не го анулирате поне 24 часа преди края на текущия период; можете да анулирате по всяко време от настройките на акаунта си в App Store. Всяко подновяване се таксува по цената, показана на бутона по-горе. Плащането се таксува от акаунта ви в App Store при потвърждаване на покупката и в началото на всеки период на подновяване.",
  "premium.freeBannerBody": "Безплатните акаунти получават GFS навсякъде — предпочитаните ви модели и „навсякъде другаде“ започват да работят в момента, в който се абонирате.",
  "premium.freeBannerTitle": "Предпочитанията важат с Premium",
  "premium.freeSubscription": "Безплатен премиум абонамент",
  "premium.freeTrialForPeriod": "Безплатен пробен период от {period, plural, one {# ден} other {# дни}}",
  "premium.getUnlimitedAccess": "Неограничен достъп до:",
  "premium.manageMySubscription": "Управление на абонамента",
  "premium.notPurchasedYet": "Не е намерена покупка на SmartMixin Premium за този акаунт в магазина.",
  "premium.orChooseMonthly": "Или изберете месечно:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Активен",
  "premium.premiumAnnualTrialInfo": "Започнете с безплатен пробен период от {days, plural, one {# ден} other {# дни}}",
  "premium.premiumCurrentPlan": "Текущ план",
  "premium.premiumDownloadApp": "Изтеглете приложението, за да се абонирате:",
  "premium.premiumEndsOn": "Изтича на {date}",
  "premium.premiumFeatureAlerts": "Метеорологични известия",
  "premium.premiumFeatureAnalysis": "Разширен анализ на времето",
  "premium.premiumFeatureCharts": "Сравнения на графики",
  "premium.premiumFeatureExport": "Експорт на данни",
  "premium.premiumFeatureForecast": "Регионални прогностични модели",
  "premium.premiumFeatureNotification": "Уиджет за лентата на състоянието",
  "premium.premiumFeatureTitle": "Premium функция",
  "premium.premiumFeatureWidgets": "Уиджети на началния екран",
  "premium.premiumFreePlan": "Безплатно",
  "premium.premiumInactive": "Без абонамент",
  "premium.premiumManageStoreSubscription": "Абонирали сте се чрез {store}. Управлявайте или анулирайте абонамента си там.",
  "premium.premiumManageWebSubscription": "Управлявайте абонамента си, актуализирайте метода на плащане или анулирайте.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Подновява се на {date}",
  "premium.premiumSubscribeAnnual": "Годишно — 9,99 €/година",
  "premium.premiumSubscribedOn": "Абониран чрез {platform}",
  "premium.premiumSubscribedOnWeb": "Абониран през уеб",
  "premium.premiumSubscribeMonthly": "Месечно — 1,99 €/месец",
  "premium.premiumSubscribeOnWeb": "Абонирайте се сега, за да отключите всички премиум функции.",
  "premium.premiumSubscriptionSuccess": "Вашият абонамент е активиран! Насладете се на всички премиум функции.",
  "premium.premiumSubscriptionSuccessTitle": "Добре дошли в Premium!",
  "premium.premiumWebappNotice": "Абонирането през уеб в момента не е налично.",
  "premium.pricePerMonth": "{price}/месец",
  "premium.pricePerYear": "{price}/година",
  "premium.purchasedNetatmoPro": "Вече сте закупили Netatmo Pro ({date}). Това ви дава достъп до подгрупа от премиум функции. Абонирайте се за една от следните оферти, ако искате да имате достъп до всички премиум функции.",
  "premium.purchaseFailed": "Покупката не можа да бъде завършена. Моля, опитайте отново.",
  "premium.restoreFailed": "Покупките ви не можаха да бъдат възстановени. Моля, опитайте отново.",
  "premium.restorePurchase": "Възстановяване на покупката",
  "premium.savingsPercent": "Спестявате {percent}%",
  "premium.seePremium": "Вижте Premium",
  "premium.startFreeTrial": "Започнете безплатен пробен период",
  "premium.storeUnavailable": "Магазинът в момента не е достъпен. Моля, опитайте по-късно.",
  "premium.subscribeNow": "Абонирай се сега — без пробен период",
  "premium.switchToPremium": "Преминете към SmartMixin Premium",
  "premium.thenPrice": "след това {price}",
  "providerHints.ambientWeatherApiKey": "Създаден в настройките на вашия акаунт в ambientweather.net.",
  "providerHints.davisApiSecret": "Показва се само веднъж при създаване на V2 API ключа — съхранявайте го на сигурно място.",
  "providerHints.davisV2ApiKey": "От страницата V2 API ключове в weatherlink.com.",
  "providerHints.ecowittApi": "От страницата API на вашия Ecowitt акаунт.",
  "providerHints.ecowittApp": "Ключът на приложението, също от вашия Ecowitt акаунт.",
  "providerHints.myAcuriteCredentialsBanner": "Използвайте имейла и паролата на вашия My AcuRite акаунт — не входа в SmartMixin.",
  "providerHints.myAcuriteEmail": "Имейлът на вашия My AcuRite акаунт — не вашия вход в SmartMixin.",
  "providerHints.myAcuritePassword": "Паролата на вашия My AcuRite акаунт.",
  "providerHints.weatherflowToken": "Личен токен от tempestwx.com → настройки → разрешения за данни.",
  "providerHints.wundergroundEditKey": "Използвай друг ключ",
  "providerHints.wundergroundKey": "Дълъг низ от страницата с API ключове на вашия Weather Underground акаунт — не вашата парола за wunderground.com.",
  "providerHints.wundergroundKeyExample": "напр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API ключът е потвърден",
  "providerHints.wundergroundNoStationsNearby": "Не са намерени станции в близост до това местоположение. Опитайте да въведете ID на станция директно.",
  "providerHints.wundergroundStationIdExample": "напр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Получете вашия Ambient Weather API ключ.",
  "providerIntro.davisStep2": "Получете вашия Davis V2 API ключ и API тайна.",
  "providerIntro.ecowittStep2": "Получете вашия Ecowitt API ключ и ключ на приложението.",
  "providerIntro.getStarted": "Започнете",
  "providerIntro.myAcuriteStep2": "Използвайте имейла и паролата на съществуващия си My AcuRite акаунт.",
  "providerIntro.netatmoEnergyStep2": "Влезте в Netatmo, когато бъдете подканени — не е необходим API ключ.",
  "providerIntro.netatmoWeatherStep2": "Влезте в Netatmo, когато бъдете подканени — не е необходим API ключ.",
  "providerIntro.signupBanner": "Почти готово — създайте безплатен SmartMixin акаунт, за да свържете {provider}.",
  "providerIntro.step1": "Влезте в своя SmartMixin акаунт (НЕ в {provider}).",
  "providerIntro.step3EmailPassword": "Въведете ги тук.",
  "providerIntro.step3KeyOrToken": "Поставете тук.",
  "providerIntro.step3OAuth": "Разрешете SmartMixin в изскачащия прозорец.",
  "providerIntro.step3Wunderground": "Поставете вашия API ключ, след което изберете близка станция или въведете произволен ID на станция.",
  "providerIntro.title": "Свържи {provider}",
  "providerIntro.weatherflowStep2": "Получете вашия личен Tempest токен.",
  "providerIntro.wundergroundBrowsePublic": "Нямате станция? Разгледайте публичните",
  "providerIntro.wundergroundFindNearby": "Намери станции наблизо",
  "providerIntro.wundergroundOrEnterId": "Или въведи ID на станция",
  "providerIntro.wundergroundStep2": "Получете вашия API ключ за Weather Underground. След това ще можете да свържете всяка станция — ваша или публична.",
  "reports.agroMeteorology": "Агрометеорология",
  "reports.analysis": "Анализи",
  "reports.annualCumulativeRainfallComparison": "Сравнение на годишните кумулативни валежи",
  "reports.annualHeatingDurationComparison": "Сравнение на продължителността на годишното отопление",
  "reports.annualHeatingEfficiency": "Годишна отоплителна ефективност",
  "reports.annualIndoorComparison": "Годишно сравнение за помещение",
  "reports.annualOutdoorComparison": "Годишно сравнение за външни измервания",
  "reports.annualOutdoorReport": "Годишен отчет за външни измервания",
  "reports.annualReport": "Годишен отчет",
  "reports.annualSolarReport": "Годишен слънчев отчет",
  "reports.annualWaterBalance": "Годишен воден баланс",
  "reports.annualWaterBalanceCarryOver": "Пренасяне от {year} ({value})",
  "reports.annualWaterBalanceDescription": "Водният баланс (опростена версия, използват се само дъжд и евапотранспирация) помага за управление на водоснабдяването",
  "reports.avgHumidity": "Средна влажност",
  "reports.avgMaxTemperature": "Средна стойност на T°max",
  "reports.avgMetric": "Средно – {metric}",
  "reports.avgMinTemperature": "Средна стойност на T°мин",
  "reports.avgPressure": "Средна стойност на налягането",
  "reports.avgTemperature": "Средна температура",
  "reports.chartsAndTable": "Графики и таблица",
  "reports.climateNormalPeriodOfRecord": "Период на измерване ({years, plural, one {# година} other {# години}})",
  "reports.climateNormals": "Климатични норми",
  "reports.climateNormalStandardLabel": "Стандартна норма ({period})",
  "reports.climateTrendPerDecade": "Тенденция на температурата: {value} на десетилетие за {years, plural, one {# година} other {# години}}",
  "reports.coldestMonthRanking": "Най-студен {month} в историята",
  "reports.comfortable": "Комфортно (45% {lessThan} Влажност ≤ 60%)",
  "reports.cumulativeRainfall": "Кумулативни валежи",
  "reports.cumulativeRainfallDescription": "Проследявайте общото количество валежи, натрупани през избрания период.",
  "reports.dailyMaxRainfall": "Максимално количество валеж за деня",
  "reports.dataExport": "Експортиране на данни",
  "reports.dataExportXlsxFormatDescription": "Експортирайте всички данни на вашата станция във формат Excel (*.xlsx). След като щракнете върху бутона, след няколко минути ще получите имейл с обработените данни.",
  "reports.daysOfData": "Данни за {days, plural, one {# ден} other {# дни}}",
  "reports.daysWithFrost": "Дни с мраз",
  "reports.daysWithHeavyRain": "Дни със силен дъжд (≥ {threshold})",
  "reports.daysWithoutThaw": "Дни без топене",
  "reports.daysWithStrongFrost": "Дни със силен мраз",
  "reports.emailSent": "До вашата пощенска кутия бе изпратен имейл",
  "reports.frostDays": "Мразовити дни",
  "reports.grasslandTemperatureSum": "Температурна сума на пасища",
  "reports.grasslandTemperatureSumDescription": "Ако сумата от {threshold} е надвишена през пролетта, устойчивото начало на вегетацията е достигнато (работи в Европа)",
  "reports.growingDegreeDays": "Градус-дни на растеж",
  "reports.highPressure": "Антициклон (средно налягане ≥ 1013 mbar)",
  "reports.iceDays": "Ледени дни",
  "reports.indoorReport": "Отчет от измервания в помещението",
  "reports.keyFacts": "Ключови факти",
  "reports.longestDrySpell": "Най-дълъг сух период",
  "reports.longestRunOfRainyDays": "Най-дългата серия от дъждовни дни",
  "reports.longestRunWithoutRun": "Най-дългата серия без дъжд",
  "reports.longestWetSpell": "Най-дълъг дъждовен период",
  "reports.lowPressure": "Ниско налягане (средно налягане {lessThan} 1013mbar)",
  "reports.maxHumidity": "Максимална влажност",
  "reports.maxMetric": "Максимум – {metric}",
  "reports.maxPressure": "Максимално налягане",
  "reports.maxTemperature": "Максимална температура",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Максимална амплитуда (/24H)",
  "reports.minHumidity": "Минимална влажност",
  "reports.minMetric": "Минимум – {metric}",
  "reports.minPressure": "Минимум на налягане",
  "reports.minTemperature": "Минимална температура",
  "reports.minTempMagnitude24h": "Минимална амплитуда (/24H)",
  "reports.monthlyAverageCountdown": "Още {days, plural, one {# ден} other {# дни}} този месец",
  "reports.monthlyAverageCountdownDetail": "Тогава ще се появят средната стойност за месеца и класирането.",
  "reports.monthlyAverageRule": "Месечните средни стойности и класирания се появяват, когато календарен месец има записани {days, plural, one {# ден} other {# дни}}.",
  "reports.monthlyHeatingEfficiency": "Месечна ефективност на отоплението",
  "reports.monthlyOutdoorReport": "Месечен отчет от измервания отвън",
  "reports.monthlyReport": "Месечен отчет",
  "reports.monthlySolarReport": "Месечен слънчев отчет",
  "reports.monthlyWindReport": "Месечен отчет за вятър",
  "reports.monthsOfData": "Данни за {months, plural, one {# месец} other {# месеца}}",
  "reports.numberOfDays": "Брой дни",
  "reports.outdoorReport": "Отчет от измервания отвън",
  "reports.overviewSection": "Общ преглед",
  "reports.rainfall": "Валежи",
  "reports.rainyDays": "Дъждовни дни",
  "reports.recordDailyRain": "Най-дъждовен ден",
  "reports.recordHigh": "Рекордна горещина",
  "reports.recordLow": "Рекорден студ",
  "reports.recordsAndClimatology": "Рекорди и климат",
  "reports.recordsSince": "Рекорди от {date}",
  "reports.recordWindGust": "Най-силен порив на вятъра",
  "reports.relativelyWet": "Относително влажно (60% {lessThan} влажност ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# отчет} other {# отчета}}",
  "reports.sendEmail": "Изпратете имейл",
  "reports.summerDays": "Летни дни",
  "reports.tooDry": "Твърде сухо (Влажност ≤ 45%)",
  "reports.tooWet": "Твърде влажно (Влажност {greaterThan} 80%)",
  "reports.tropicalNights": "Тропически нощи",
  "reports.unlockPremiumSubtitle": "Включено в SmartMixin Premium",
  "reports.unlockPremiumTitle": "Отключете {count, plural, one {# премиум функция} other {# премиум функции}}",
  "reports.warmestMonthRanking": "Най-топъл {month} в историята",
  "reports.waterBalance": "Воден баланс",
  "reports.yearsOfData": "Данни за {years, plural, one {# година} other {# години}}",
  "reports.yearToDateTemperatureComparison": "Сравнение на температурата от началото на годината",
  "sensors.bgtSensors": "Черна сфера и WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareHumidity": "Сравнение на влажността",
  "sensors.compareMoisture": "Сравнение на влагата",
  "sensors.comparePm25": "Сравнение на PM2.5",
  "sensors.compareTemperatures": "Сравнение на температурите",
  "sensors.compareWaterTension": "Сравнение на водното напрежение на почвата",
  "sensors.depthByChannel": "Дълбочина по канал",
  "sensors.heatStressExtreme": "Екстремен топлинен стрес",
  "sensors.heatStressModerate": "Умерен топлинен стрес",
  "sensors.heatStressNone": "Няма топлинен стрес",
  "sensors.heatStressStrong": "Силен топлинен стрес",
  "sensors.heatStressVeryStrong": "Много силен топлинен стрес",
  "sensors.indoorClimate": "Вътрешен климат",
  "sensors.indoorCo2Levels": "Нива на CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура и влажност",
  "sensors.leafWetnessByChannel": "Влажност на листата по канал",
  "sensors.lightningSensor": "Мълния",
  "sensors.moistureByChannel": "Влага по канал",
  "sensors.noDataAvailable": "Няма налични данни",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 по канал",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Изберете канал",
  "sensors.sensorDetailDescription": "Преглед на исторически данни и тенденции за каналите на сензора.",
  "sensors.sensorHistory": "История на сензора",
  "sensors.soilConductivityByChannel": "Проводимост по канал",
  "sensors.soilTemperatureByChannel": "Температура на почвата по канал",
  "sensors.strikesToday": "Удари днес",
  "sensors.temperatureByChannel": "Температура по канал",
  "sensors.viewChart": "Преглед на графиката",
  "sensors.waterTensionByChannel": "Водно напрежение на почвата по канал",
  "settings.appearance": "Външен вид",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "арабски",
  "settings.bulgarian": "български",
  "settings.catalan": "каталонски",
  "settings.chartGestures": "Жестове върху графики",
  "settings.chartGesturesDescription": "Плъзгането върху диаграмите променя периода от време, прищипването на диаграмите променя времевата скала",
  "settings.choiceCount": "{count, plural, one {Наличен: #} other {Налични: #}}",
  "settings.contactUs": "Свържете се с нас",
  "settings.contactUsDescription": "Получете помощ или изпратете обратна връзка",
  "settings.croatian": "хърватски",
  "settings.czech": "чешки",
  "settings.dailyDetailByPeriods": "Дневни подробности по периоди",
  "settings.dailyDetailByPeriodsDescription": "Групиране на 24-те часа в нощ, сутрин, следобед и вечер — същото разделение, което използва обобщението за деня.",
  "settings.danish": "датски",
  "settings.dark": "Тъмна тема",
  "settings.dataDisplay": "Показване на данни",
  "settings.dateAndTime": "Дата и час",
  "settings.donateButton": "Направете дарение",
  "settings.donateDescription": "SmartMixin се разработва от малък екип. Ако ви е полезен, можете да подкрепите развитието му с еднократно дарение в произволен размер. Това е подарък — не променя плана ви и не отключва никакви функции.",
  "settings.donateSuccessBody": "Вашето дарение помага на SmartMixin да продължи да работи и да се подобрява. Наистина го оценяваме.",
  "settings.donateSuccessTitle": "Благодарим за подкрепата!",
  "settings.donateTitle": "Подкрепете SmartMixin",
  "settings.dragToReorder": "Плъзнете, за да пренаредите",
  "settings.dutch": "холандски",
  "settings.english": "английски",
  "settings.french": "френски",
  "settings.german": "немски",
  "settings.gestures": "Жестове",
  "settings.greek": "гръцки",
  "settings.hungarian": "унгарски",
  "settings.italian": "италиански",
  "settings.japanese": "японски",
  "settings.korean": "корейски",
  "settings.language": "Език",
  "settings.languageDescription": "Предпочитан език",
  "settings.light": "Светла тема",
  "settings.measurementUnits": "Мерни единици",
  "settings.netatmoDashboard": "Табло Netatmo",
  "settings.netatmoLayoutCards": "Списък с карти",
  "settings.netatmoLayoutCardsDescription": "По една карта на модул, всичко в един списък",
  "settings.netatmoLayoutClassic": "Класическо",
  "settings.netatmoLayoutClassicDescription": "Две карти, плъзгане между модулите",
  "settings.netatmoNewLayoutNotice": "Ново оформление на таблото: по една карта на модул.",
  "settings.netatmoSwitchBackToClassic": "Обратно към класическото",
  "settings.netatmoSwitchToLayout": "Превключи към {layout}",
  "settings.norwegian": "норвежки",
  "settings.notificationsSection": "Известия",
  "settings.ongoingNotificationEnabled": "Активиране на постоянно известие",
  "settings.ongoingNotificationMetrics": "Показвани измервания",
  "settings.ongoingNotificationPermissionRequired": "Изисква се разрешение за известия",
  "settings.ongoingNotificationPreviewHint": "Преглед — включете уиджета, за да се показва",
  "settings.ongoingNotificationStatusBar": "Лента на състоянието",
  "settings.polish": "полски",
  "settings.portuguese": "португалски",
  "settings.preferencesSection": "Предпочитания",
  "settings.privacyPolicy": "Политика за поверителност",
  "settings.russian": "руски",
  "settings.serbian": "сръбски",
  "settings.settings": "Настройки",
  "settings.settingsPageTitle": "Настройки - {page}",
  "settings.slovak": "словашки",
  "settings.smallDecimals": "Малки десетични",
  "settings.smallDecimalsDescription": "Показване на десетичните цифри в по-малък размер",
  "settings.spanish": "испански",
  "settings.statusBarWidget": "Уиджет за лентата на състоянието",
  "settings.statusBarWidgetDescription": "Винаги видими метеорологични данни",
  "settings.subscriptionSection": "Абонамент",
  "settings.supportSection": "Поддръжка",
  "settings.swedish": "шведски",
  "settings.systemTheme": "Системна тема",
  "settings.termsOfService": "Условия за ползване",
  "settings.turkish": "турски",
  "settings.ukrainian": "украински",
  "settings.units": "Единици",
  "settings.unitsDescription": "Мерни единици в приложението",
  "settings.update": "Обновете",
  "settings.windDirectionConvention": "Стрелка за посока на вятъра",
  "settings.windDirectionConventionDescription": "Изберете как да се показват стрелките за посока на вятъра",
  "settings.windDirectionMeteorological": "Посока на произход",
  "settings.windDirectionMeteorologicalDescription": "Стрелката показва откъде духа вятърът (метеорологична конвенция)",
  "settings.windDirectionOceanographic": "Посока на потока",
  "settings.windDirectionOceanographicDescription": "Стрелката показва накъде духа вятърът (океанографска конвенция)",
  "stations.addAStation": "Добавете станция",
  "stations.addToFavorites": "Добавете към любими",
  "stations.addYourOwnStation": "Добавете своята станция",
  "stations.clearRecentLocations": "Изчистете всички",
  "stations.clearSearch": "Изчистване на търсенето",
  "stations.currentLocation": "Текущо местоположение",
  "stations.customizedStationName": "Персонализирано име на станция",
  "stations.favoriteLocations": "Любими",
  "stations.favoriteLocationsEmpty": "Можете да добавите до 5 любими места.",
  "stations.favoriteStations": "Любими станции",
  "stations.filterStationDescription": "Не показвайте станции с ненадеждни измервания",
  "stations.filterStations": "Филтрирайте станции",
  "stations.filterStationSourceDescription": "Изберете доставчици на станции, които искате да покажете на картата",
  "stations.findStationsNearYou": "Намерете станции наблизо",
  "stations.hiddenStations": "Скрити станции",
  "stations.hiddenStationsDescription": "Можете да покажете отново станция, като докоснете иконата с око до нея.",
  "stations.lastSeen": "последно {time}",
  "stations.location": "Местоположение",
  "stations.locationAddedToFavorites": "Местоположението е добавено към любими",
  "stations.locationNotGranted": "Разрешението за местоположение не се предоставя. Моля, разрешете достъп до вашето местоположение в настройките на устройството.",
  "stations.locationRemovedFromFavorites": "Местоположението е премахнато от любими",
  "stations.locations": "Местоположения",
  "stations.locationUnavailable": "Местоположението ви не може да бъде определено. Моля, проверете настройките на устройството.",
  "stations.maxFavoriteLocationsReached": "Можете да имате само до 5 любими места. Премахнете едно, за да добавите друго.",
  "stations.modifyFavoriteStations": "Променете любимите станции",
  "stations.modifyFavoriteStationsDescription": "Можете да пренаредите любимите си станции, като ги плъзнете. Можете също да ги премахнете от списъка.",
  "stations.myLocation": "Моето местоположение",
  "stations.nearbyWeatherStations": "Метеорологични станции наблизо",
  "stations.noLocationsFound": "Няма намерени места",
  "stations.noSearchResults": "Няма статии, отговарящи на търсенето ви",
  "stations.noStationsFound": "Не са намерени станции",
  "stations.noWeatherStationYet": "Все още нямате метеорологична станция.",
  "stations.recentLocations": "Скорошни",
  "stations.recentLocationsEmpty": "Историята ви е празна.",
  "stations.removeFromFavorites": "Премахнете от любими",
  "stations.searchForLocation": "Потърсете местоположение",
  "stations.searchForWeatherStation": "Потърсете метеорологична станция",
  "stations.searchResults": "Резултати от търсенето",
  "stations.searchResultsEmpty": "Не са намерени резултати.",
  "stations.searchResultsFound": "{count, plural, one {# намерен резултат} other {# намерени резултата}}",
  "stations.searchStationsDescription": "Въведете град, адрес или име на място, за да намерите метеорологични станции наблизо.",
  "stations.searchStationsHint": "Използвайте лентата за търсене по-горе, за да откриете метеорологични станции навсякъде по света.",
  "stations.selectStationForComparison": "Изберете станция за сравнение",
  "stations.stationAddedToFavorites": "Станцията е добавена към любими",
  "stations.stationCount": "{count, plural, one {# станция} other {# станции}}",
  "stations.stationInformation": "Информация за станцията",
  "stations.stationName": "Име на станцията",
  "stations.stationObservationsDescription": "Показване на последните наблюдения от метеорологичните станции",
  "stations.stationRemovedFromFavorites": "Станцията е премахната от любимите",
  "stations.stationsNear": "Станции близо до {place}",
  "stations.stationType": "Тип станция",
  "stations.statusOffline": "Офлайн",
  "stations.statusOnline": "Онлайн",
  "stations.statusStale": "Остаряло",
  "stations.tryAnotherLocation": "Не намерихме метеорологични станции близо до това място. Опитайте да търсите в друг район.",
  "stations.weatherStation": "Метеорологична станция",
  "stations.weatherStationCount": "{count, plural, one {# метеорологична станция} other {# метеорологични станции}}",
  "stations.weatherStations": "Метеорологични станции",
  "stations.welcomeConnectService": "Имате метеорологична станция? Свържете услугата си",
  "stations.welcomeSubtitle": "Вашето време, всичко на едно място",
  "thermostat.away": "Отсъствие",
  "thermostat.boilerOn": "Нагревател ВКЛ",
  "thermostat.hg": "Защита от замръзване",
  "thermostat.homeInformation": "Информация за дома",
  "thermostat.homeName": "Име на дома",
  "thermostat.manualBoost": "Ръчно усилване",
  "thermostat.manualSetpointUntil": "Ръчна настройка до",
  "thermostat.noThermostatYet": "Все още нямате термостат.",
  "thermostat.relay": "Реле",
  "thermostat.room": "Стая",
  "thermostat.rooms": "Стаи",
  "thermostat.smartThermostat": "Интелигентен термостат",
  "thermostat.smartValve": "Интелигентен клапан",
  "thermostat.whenBackHome": "Кога ще се приберете у дома?",
  "units.celsius": "Целзий",
  "units.fahrenheit": "Фаренхайт",
  "units.inch": "Инчове",
  "units.inchOfMercury": "Инчове живачен стълб",
  "units.kelvin": "Келвин",
  "units.kilometerPerHour": "Километри в час",
  "units.knot": "Възли",
  "units.meterPerSecond": "Метри в секунда",
  "units.milePerHour": "Мили в час",
  "units.millibar": "Милибари",
  "units.millimeter": "Милиметри",
  "units.millimeterOfMercury": "Милиметри живачен стълб",
  "weatherConditions.blizzard": "Виелица",
  "weatherConditions.blowingDust": "Прах, носен от вятъра",
  "weatherConditions.blowingSnow": "Снегонавявания",
  "weatherConditions.breezy": "Слаб вятър",
  "weatherConditions.clear": "Ясно",
  "weatherConditions.cloudy": "Облачно",
  "weatherConditions.drizzle": "Ръмеж",
  "weatherConditions.flurries": "Слаб снеговалеж",
  "weatherConditions.foggy": "Мъгла",
  "weatherConditions.freezingDrizzle": "Замръзващ ръмеж",
  "weatherConditions.freezingRain": "Замръзващ дъжд",
  "weatherConditions.frigid": "Силен студ",
  "weatherConditions.hail": "Градушка",
  "weatherConditions.haze": "Мараня",
  "weatherConditions.heavyRain": "Силен дъжд",
  "weatherConditions.heavySnow": "Силен снеговалеж",
  "weatherConditions.hot": "Горещо",
  "weatherConditions.hurricane": "Ураган",
  "weatherConditions.isolatedThunderstorms": "Изолирани гръмотевични бури",
  "weatherConditions.mixedRainAndHail": "Дъжд и градушка",
  "weatherConditions.mostlyClear": "Предимно ясно",
  "weatherConditions.mostlyCloudy": "Предимно облачно",
  "weatherConditions.mostlySunny": "Предимно слънчево",
  "weatherConditions.notAvailable": "Метеорологичните условия не са налични",
  "weatherConditions.partlyCloudy": "Частична облачност",
  "weatherConditions.rain": "Дъжд",
  "weatherConditions.rainSleet": "Дъжд и ледени зърна",
  "weatherConditions.rainSnow": "Дъжд и сняг",
  "weatherConditions.scatteredShowers": "Разпръснати превалявания",
  "weatherConditions.scatteredSnowShowers": "Разпръснати снежни превалявания",
  "weatherConditions.scatteredThunderstorms": "Разпръснати гръмотевични бури",
  "weatherConditions.showers": "Превалявания",
  "weatherConditions.sleet": "Ледени зърна",
  "weatherConditions.smoke": "Дим",
  "weatherConditions.snow": "Сняг",
  "weatherConditions.snowShowers": "Снежни превалявания",
  "weatherConditions.strongStorms": "Силни гръмотевични бури",
  "weatherConditions.sunny": "Слънчево",
  "weatherConditions.thunderstorms": "Гръмотевични бури",
  "weatherConditions.tornado": "Торнадо",
  "weatherConditions.tropicalStorm": "Тропическа буря",
  "weatherConditions.windy": "Ветровито",
  "weatherConditions.wintryMix": "Смесени зимни валежи",
  "weatherMap.legendHeavy": "Силен",
  "weatherMap.legendLight": "Слаб",
  "weatherMap.legendLightningHelp": "Цветът показва възрастта на всяка мълния през последните {minutes} минути — най-новите в бяло, най-старите в тъмночервено.",
  "weatherMap.legendNewest": "Най-нови",
  "weatherMap.legendOldest": "Най-стари",
  "weatherMap.legendStationsHelp": "Цветът на маркера отразява стойността на избрания показател.",
  "weatherMap.lightningDataAttribution": "Данни за мълнии: Blitzortung.org",
  "weatherMap.lightningStrikes": "Мълнии",
  "weatherMap.lightningStrikesDescription": "Показване на мълниите в реално време върху картата",
  "weatherMap.mapLayers": "Слоеве на картата",
  "weatherMap.mapLegend": "Легенда на картата",
  "weatherMap.radarDataAttribution": "Данни от радар: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Радар за дъжд",
  "weatherMap.rainRadarDescription": "Показване на наслагване на радар за дъжд върху картата",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain е допълнителен източник на данни, предоставен чрез Tempest Weather System, захранван от Nearcast Technology. NC Rain данните са оценка на средното натрупване на валежи около вашия Tempest на ниво квартал",
  "weatherMap.weatherMap": "Метеорологична карта",
  "weatherMap.weatherMapMetaDescription": "SmartMixin предлага интерактивни карти на времето и радара за метеорологични условия по целия свят.",
  "weatherWarnings.activeNow": "Активни сега",
  "weatherWarnings.fromTime": "От {time}",
  "weatherWarnings.hazardAirQuality": "Качество на въздуха",
  "weatherWarnings.hazardAvalanche": "Лавини",
  "weatherWarnings.hazardCoastalEvent": "Крайбрежни опасности",
  "weatherWarnings.hazardFlood": "Наводнения",
  "weatherWarnings.hazardFog": "Мъгла",
  "weatherWarnings.hazardForestFire": "Горски пожари",
  "weatherWarnings.hazardHighTemperature": "Високи температури",
  "weatherWarnings.hazardLowTemperature": "Ниски температури",
  "weatherWarnings.hazardOther": "Друга опасност",
  "weatherWarnings.hazardRain": "Дъжд",
  "weatherWarnings.hazardSnowIce": "Сняг и заледяване",
  "weatherWarnings.hazardThunderstorm": "Гръмотевични бури",
  "weatherWarnings.hazardUv": "UV лъчение",
  "weatherWarnings.hazardWind": "Вятър",
  "weatherWarnings.lastUpdate": "Последна актуализация: {time}",
  "weatherWarnings.severityExtreme": "Екстремна",
  "weatherWarnings.severityFrom": "{severity} от {time}",
  "weatherWarnings.severityMinor": "Ниска",
  "weatherWarnings.severityModerate": "Умерена",
  "weatherWarnings.severityNow": "{severity} сега",
  "weatherWarnings.severitySevere": "Сериозна",
  "weatherWarnings.severityUntil": "{severity} до {time}",
  "weatherWarnings.source": "Източник: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, след това {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# официално метеорологично предупреждение} other {# официални метеорологични предупреждения}}. {hazards}",
  "weatherWarnings.upcoming": "Предстоящи"
}
